<div class="row justify-content-md-center no-gutters greyBgBody marL10">
    <app-loader-icon *ngIf="showLoader"></app-loader-icon>
    <div class="col-12 sessionAudienceSection whiteBg">
        <div class="panel-group" id="accordion">
            <form name="addSessionForm" class="addSessionForm" (ngSubmit)="f.form.valid && onSubmit($event,f.form)" #f="ngForm"
                (keydown.enter)="$event.preventDefault()">
                <div class="panel panel-default">
                    <div class="collapse in show">
                        <div class="panel-body">
                            <div class="row">
                              <div class="col-8">
                                <h5 class="sectionTitleBig">Session Request</h5>
                                <h6 class="sectionTitle">Session Audience</h6>
                                <span class="infoIconSmall-sessionAudience"
                                      *ngIf="session.approvalStatus == 'Approved' && (userRoleID != 1 && userRoleID != 3 )&& (session.sponsoredCountry == 23 || session.sponsoredCountry == 259 || session.sponsoredCountry == 265 || session.sponsoredCountry == 267 || session.sponsoredCountry == 268 || session.sponsoredCountry == 269  )"
                                      title="If you would like to change the audience type, get in touch with Chief Chemist."></span>
                                <span class="infoIconSmall-sessionAudience"
                                      *ngIf="session.approvalStatus == 'Approved' && (userRoleID != 1 && userRoleID != 3) && session.sponsoredCountry != 23 && session.sponsoredCountry != 259 && session.sponsoredCountry != 265 && session.sponsoredCountry != 267 && session.sponsoredCountry != 268 && session.sponsoredCountry != 269"
                                      title="If you would like to change the audience type, get in touch with your Regional Chief."></span>


                              </div>

                <div class="col-4">
                  <!-- According to this CR: 2650777, for internal deloitte status of session should be present -->
                  <h6 class="status-align" *ngIf="isSelected('Deloitte') ">
                    Status : <span>{{session?.approvalStatus}}</span>
                  </h6>
                  <h6 class="status-align"
                      *ngIf="isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience')">
                    Status : <span>{{session?.approvalStatus}}</span>
                  </h6>
                </div>
              </div>
              <div class="row audiencesRadios">
                <div class="col">
                  <span title="Internal session for Deloitte participants only, requires Deloitte email">
                    <input type="radio" name="sessionType" [(ngModel)]="session.sessionType"
                           [attr.disabled]="disableDeloitte"
                           (click)="onSessionAudienceChange('Deloitte', true);enableContentArea()"
                           value="Deloitte" id="Deloitte"
                           [disabled]="isSessionCreatedFromCommercialization || disableSubscriptionFields ||(eventName!='' && eventName!=null)"
                           [title]="(disableDeloitte && NonDeloitteUsersCount > 0) ? 'External users assessments are associated with this link' : 'Internal session for Deloitte participants only, requires Deloitte email'" />
                    <label for="Deloitte">Internal Deloitte</label>
                  </span>
                  <span title="Session for active Deloitte client">
                    <input type="radio" name="sessionType" [(ngModel)]="session.sessionType"
                           [attr.disabled]="disableExternalClient"
                           (click)="onSessionAudienceChange('ExternalClient', true);enableContentArea()"
                           value="ExternalClient" id="ExternalClient"
                           [disabled]="isSessionCreatedFromCommercialization || disableSubscriptionFields || (eventName!='' && eventName!=null)" />
                    <label for="ExternalClient">Client</label>
                  </span>
                  <span title="Session with no clients present, e.g. non-client non-profit, students, or Deloitte team + sub-contractors">
                    <input type="radio" name="sessionType" [(ngModel)]="session.sessionType"
                           [attr.disabled]="disableExternalNonClient"
                           (click)="onSessionAudienceChange('ExternalNonClient', true);enableContentArea()"
                           value="ExternalNonClient" id="ExternalNonClient"
                           [disabled]="isSessionCreatedFromCommercialization || disableSubscriptionFields || (eventName!='' && eventName!=null )" />
                    <label for="ExternalNonClient">Non-client</label>
                  </span>
                  <span title="Session for mixed client/non-client, e.g. external Deloitte program, professional association, or board of directors">
                    <input type="radio" name="sessionType" [(ngModel)]="session.sessionType"
                           [attr.disabled]="disableMixedAudience"
                           (click)="onSessionAudienceChange('MixedAudience', true);enableContentArea()"
                           value="MixedAudience" id="mixedAudience"
                           [disabled]="isSessionCreatedFromCommercialization || disableSubscriptionFields || (eventName!='' && eventName!=null)" />
                    <label for="mixedAudience">
                      Mixed
                      Audience
                    </label>
                  </span>
                </div>
              </div>
              <h5 *ngIf="isSelected('Deloitte')" class="sectionTitle">
                <span *ngIf="sessionId == 0">New</span><span *ngIf="sessionId != 0">Edit</span> Session
              </h5>
              <div class="row"
                   *ngIf="isSelected('Deloitte') || isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience') || (session.showsession)">
                <div class="col-4">
                  <div class="">
                    <label for="sessionName">
                      Session Name (auto-populated)<span class="mandatoryMark">*</span>
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="session.sessionName"
                           #sessionName="ngModel" name="sessionName"
                           [ngClass]="{ 'is-invalid': (f.submitted && sessionName.invalid) || invalidSessionName}"
                           [disabled]="(userRoleID != 1 && userRoleID != 3 && session.approvalStatus != 'Draft') || ((userRoleID == 1 || userRoleID == 3) && disableSessionName)"
                           (focusout)="onFocusOutSessionName($event)" required />
                  </div>
                  <span class="error-message"></span>
                </div>
                <div class="col-5 sessionLink" [hidden]="InvalidAge"
                     *ngIf="session.sessionLink && (isSelected('Deloitte') || ((sessionId !== 0 && userRoleID != 2 && userRoleID != 8 && userRoleID != 6) || (userRoleID == 2 && session.approvalStatus != 'To Review' && session.approvalStatus != 'Approval Pending') || (userRoleID == 8 && session.approvalStatus != 'To Review' && session.approvalStatus != 'Approval Pending') || (sessionId !== 0 && userRoleID == 6)))">
                  <label for="sessLink">Session Link</label>
                  <span *ngIf="isLinkCopied" class="copy-link">Session link has been copied</span>
                  <input class="form-control" id="sessLink" type="text" name="sessionLink"
                         [(ngModel)]="session.sessionLink" #sessionLink="ngModel"
                         [ngClass]="{ 'is-invalid': f.submitted && sessionLink.invalid }" disabled
                         required />
                  <span class="infoIconSmall"
                        [ngClass]="{'handIcon': session.sessionLink, 'copied-style':isLinkCopied}"
                        (click)="copySessionLink()"
                        [title]="session.sessionLink ? 'Copy Session Link' : '' "></span>


                </div>

                                <div class="col-3 sessionLinkDatepicker"
                                    *ngIf="session.sessionLink && !InvalidAge && (isSelected('Deloitte') || ((sessionId !== 0 && userRoleID != 2 && userRoleID != 8 && userRoleID != 6) || (userRoleID == 2 && session.approvalStatus != 'To Review' && session.approvalStatus != 'Approval Pending') || (userRoleID == 8 && session.approvalStatus != 'To Review' && session.approvalStatus != 'Approval Pending') || (sessionId !== 0 && userRoleID == 6)))">
                                    <label for="linkExpireInput">Link Expiration </label>
                                    <div class="form-group">
                                        <div class="input-group" [ngClass]="{'disabled': disableLinkExpire}">
                                            <input id="linkExpireInput" [minDate]="session.sessionDate"
                                                [maxDate]="maximumDate" class="form-control" placeholder="mm-dd-yyyy"
                                                name="linkExpire" (click)="d1.toggle()" [(ngModel)]="session.linkExpire"
                                                #linkExpire="ngModel" ngbDatepicker #d1="ngbDatepicker"
                                                dateFormat="mm-dd-yyyy"
                                                [ngClass]="{ 'is-invalid': f.submitted && linkExpire.invalid }"
                                                [disabled]="disableLinkExpire || (eventName!='' && eventName!=null && session.subscriptionId)">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary calendar2"
                                                    (click)="d1.toggle()" type="button">
                                                    <i class="fa fa-calendar"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

              </div>



            </div>
          </div>
        </div>

        <div *ngIf="isSelected('Deloitte') || isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience') || (session.showsession) ">

          <!--1 Accordian Organization Details-->
          <div class="panel panel-default" id="tab1">
            <div class="panel-heading organization" (click)="userRoleService.closeAccordion('#collapse2')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab1')">
                <a data-bs-parent="#accordion" aria-expanded="true" data-bs-target="#collapse2"
                   aria-controls="collapse2">
                  Organization
                  Details
                </a>
              </h4>
            </div>
            <div id="collapse2" class="panel-collapse collapse accordion1">
              <div class="panel-body">
                <div class="newAudience"
                     *ngIf="isSelected('Deloitte') || isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience') || (session.showsession) ">
                  <div id="accordn1" class="col-12 sessonInforamtion">
                    <div class="row" *ngIf="!isSelected('Deloitte')">
                      <div class="col"
                           *ngIf="userRoleID == 1 || userRoleID == 6 || isUserSubscriptionAdminForSession || userRoleID ==3 ">
                        <label for="subscriptionID">Subscription Id</label>
                        <input id="subscriptionID" type="text"
                               class="form-control forOrgLabel"
                               (focusout)="onFocusOutSubscriptionField($event)"
                               (ngModelChange)="generateSessionName()" name="subscriptionId"
                               [(ngModel)]="session.subscriptionId" #subscriptionId="ngModel"
                               [ngClass]="{ 'is-invalid': (f.submitted && subscriptionId.invalid) || subscriptionIDError || isSubscriptionStatusError, 'reduce-bottom-margin' : subscriptionIDError || isSubscriptionStatusError ,'Mar16': isSelected('ExternalClient') && isDisplaySubText, 'Mar12': !(isSelected('ExternalClient') && isDisplaySubText)}"
                               [disabled]="sessionId !== 0 && (userRoleID == 6 || isUserSubscriptionAdminForSession) && (userRoleID != 1)" />
                        <span class="infoIconSmall top45px" id="subscriptionID_info"
                              title="Enter only if part of larger subscription"
                              [ngClass]="{'disabled-icon': (sessionId !== 0 && (userRoleID == 6 || isUserSubscriptionAdminForSession) && (userRoleID != 1))}"></span>
                        <span *ngIf="(subscriptionIDError || isSubscriptionStatusError)"
                              class="error-message">
                          {{
isSubscriptionStatusError ?
                                                    subscriptionStatusErrorMesg : subscriptionIDErrormessage
                          }}
                        </span>
                      </div>
                      <div class="col">
                        <label for="companyID">
                          Company/Organization <span class="mandatoryMark">*</span>
                        </label>
                        <span class="company_tooltip"
                              *ngIf="isSelected('ExternalClient') && isDisplaySubText">
                          Please
                          select an organization from the verified client names below
                        </span>
                        <input id="companyID" type="text"
                               class="form-control forOrgLabel"
                               name="companyName" [(ngModel)]="session.companyName"
                               [ngbTypeahead]="searchCompanies" [resultFormatter]="formatMatches"
                               [inputFormatter]="formatMatches"
                               (focusout)="onFocusOutCompany($event)"
                               (selectItem)="onCompanySelect($event)" #companyName="ngModel"
                               [ngClass]="{ 'is-invalid': f.submitted && (companyName.invalid || invalidCompany ),'Mar16': isSelected('ExternalClient') && isDisplaySubText, 'Mar12': !(isSelected('ExternalClient') && isDisplaySubText)}"
                               [attr.value]='session.companyName'
                               [disabled]="(sessionId !== 0 && session.approvalStatus =='Approval Pending' && userRoleID==4) || (sessionId !== 0 && session.approvalStatus =='Approved' && userRoleID!=1 && userRoleID!=3)"
                               required />

                      </div>
                      <div class="col">
                        <label for="select-ClientProgram">Client Program</label>
                        <div class="form-group">
                          <select class="form-control forOrgLabel custom-select"
                                  id="select-ClientProgram" name="clientProgram"
                                  #clientProgram="ngModel" [(ngModel)]="session.clientProgram"
                                  [disabled]="(sessionId !== 0 && (session.approvalStatus == 'Approved' &&  session.subscriptionId)||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId   && (userRoleID == 6 || userRoleID == 3 || userRoleID == 5)) || (userRoleID == 4)))) || disableSubscriptionFields"
                                  [ngClass]="{ 'is-invalid': f.submitted && clientProgram.invalid ,'Mar16': isSelected('ExternalClient') && isDisplaySubText, 'Mar12': !(isSelected('ExternalClient') && isDisplaySubText) }">
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData.ClientPrograms"
                                    [attr.selected]="item.ClientProgramID==session.ClientProgramID?true:null"
                                    [attr.value]='item.ClientProgramID'>
                              {{item.ClientProgramName}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                      </div>
                      <div class="col"
                           *ngIf="userRoleID != 1 && userRoleID != 6 && userRoleID != 3">
                        <label for="selectsecRestricted">
                          SEC Restricted? <span *ngIf="isSelected('ExternalClient') || isSelected('MixedAudience')"
                                                class="mandatoryMark">*</span>
                        </label>
                        <div class="form-group">
                          <select id="selectsecRestricted"
                                  class="form-control forOrgLabel custom-select"
                                  name="secRestricted" [(ngModel)]="session.secRestricted"
                                  #secRestricted="ngModel"
                                  [ngClass]="{ 'is-invalid': f.submitted && secRestricted.invalid }"
                                  [disabled]="(sessionId !== 0 && session.approvalStatus == 'Approved' && (userRoleID == 4 ||(session.subscriptionId && userRoleID == 3)))|| (session.subscriptionId && session.approvalStatus == 'Approval Pending' ) || isSelected('ExternalNonClient') || disableSubscriptionFields"
                                  [required]="isSelected('ExternalClient') || isSelected('MixedAudience')">
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData.SECRestriction"
                                    [attr.selected]="item.SecRestrictionID==session.SecRestrictionID?true:null"
                                    [attr.value]='item.SecRestrictionID'>
                              {{item.Name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                          <span class="infoIconSmall-secRestrict forOrgLabel"
                                title="Use DESC to look up the status of the client. SEC restricted entities are defined as SEC attest clients and/or its affiliates. "
                                [ngClass]="{'disabled-icon': (sessionId !== 0 && userRoleID == 4) || isSelected('ExternalNonClient')}"></span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4"
                           *ngIf="!isSelected('Deloitte') && (userRoleID == 1 || userRoleID == 6 || userRoleID == 3 )">
                        <label for="selectSecRest">
                          SEC Restricted? <span *ngIf="isSelected('ExternalClient') || isSelected('MixedAudience')"
                                                class="mandatoryMark">*</span>
                        </label>
                        <div class="form-group">
                          <select id="selectSecRest" class="form-control custom-select"
                                  name="secRestricted" [(ngModel)]="session.secRestricted"
                                  #secRestricted="ngModel"
                                  [ngClass]="{ 'is-invalid': f.submitted && secRestricted.invalid }"
                                  [disabled]=" (sessionId !== 0 && session.approvalStatus == 'Approved') ||
                                                            isSelected('ExternalNonClient') ||
                                                            disableSubscriptionFields"
                                  [required]="isSelected('ExternalClient') || isSelected('MixedAudience')">
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData.SECRestriction"
                                    [attr.selected]="item.SecRestrictionID==session.SecRestrictionID?true:null"
                                    [attr.value]='item.SecRestrictionID'>
                              {{item.Name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                          <span class="infoIconSmall-secRestrict"
                                title="Use DESC to look up the status of the client. SEC restricted entities are defined as SEC attest clients and/or its affiliates."
                                [ngClass]="{'disabled-icon': (sessionId !== 0 && (userRoleID != 1 && userRoleID != 3 ) ) || isSelected('ExternalNonClient')}"></span>
                        </div>
                      </div>
                      <div class="col-4">
                        <label for="selectsponsoredCountry">
                          Sponsoring Country/Location <span class="mandatoryMark">*</span>
                        </label>
                        <div class="form-group">
                          <select id="selectsponsoredCountry"
                                  class="form-control custom-select" #sponsoredCountry="ngModel"
                                  name="sponsoredCountry" placeholder="Select"
                                  [(ngModel)]="session.sponsoredCountry"
                                  (ngModelChange)="sponsoredCountryChange($event);resetOptOut();resetInvalidAge();onOpenChargeCodeAccordian();"
                                  [disabled]="disableSponsoredCountry || disableSubscriptionFields || (sessionId !== 0 && (( session.approvalStatus != 'Draft' && userRoleID == 4) || (session.approvalStatus == 'Approved' && (userRoleID == 2 || userRoleID == 8 || userRoleID == 5 || userRoleID == 6))))"
                                  [ngClass]="{ 'is-invalid': f.submitted && sponsoredCountry.invalid }"
                                  required>
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of sponsoringCountries"
                                    [attr.selected]="item.ID==session.countryid?true:null"
                                    [attr.value]='item.ID'>
                              {{item.Name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                      </div>
                    </div>

                    <div class="row" *ngIf="!showNAFields;else fieldsWithNAFields">
                      <div class="col-4">
                        <label for="selectServiceLineFunc">
                          Service Line/Function <span class="mandatoryMark">*</span>
                        </label>
                        <div class="form-group">
                          <select id="selectServiceLineFunc"
                                  class="form-control custom-select" name="serviceLineFunction"
                                  [(ngModel)]="session.serviceLineFunction"
                                  (ngModelChange)="onServiceFunctionChange($event)"
                                  #serviceLineFunction="ngModel"
                                  [ngClass]="{ 'is-invalid': f.submitted && serviceLineFunction.invalid }"
                                  [disabled]="disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')"
                                  required>
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData.ServiceFunctions"
                                    [attr.selected]="item.ID==session.serviceLineFunction?true:null"
                                    [attr.value]='item.ID'>
                              {{item.Name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                      </div>
                      <div class="col-4">
                        <label for="sessionIndustryTop">Industry <span class="mandatoryMark">*</span></label>
                        <div class="form-group">
                          <select id="sessionIndustryTop" (ngModelChange)="industryChange($event)"
                                  class="form-control custom-select" name="sessionIndustry"
                                  [(ngModel)]="session.sessionIndustry" #sessionIndustry="ngModel"
                                  [ngClass]="{ 'is-invalid': f.submitted && sessionIndustry.invalid }"
                                  [disabled]="disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')"
                                  required>
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData.Industries"
                                    [attr.selected]="item.ID==session.industryid?true:null"
                                    [attr.value]='item.ID'
                                    [hidden]="item.IsMDR || (!showNAFields && item.ID == 34)">
                              {{item.Name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                      </div>
                      <div class="col-4">
                        <label for="sessionSector">
                          Sector <span class="mandatoryMark">*</span>
                        </label>
                        <div class="form-group">
                          <select class="form-control custom-select" name="sessionSector"
                                  [(ngModel)]="session.sessionSector"
                                  (ngModelChange)="onSectorChange($event)"
                                  #sessionSector="ngModel"
                                  [ngClass]="{ 'is-invalid': f.submitted && sessionSector.invalid }"
                                  [disabled]="disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')"
                                  required>
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData_Sectors"
                                    [attr.selected]="item.SectorID==session.sectorid?true:null"
                                    [attr.value]='item.SectorID'>
                              {{item.SectorName}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                      </div>
                    </div>
                    <ng-template #fieldsWithNAFields>
                      <div class="row">
                        <div class="col-4">
                          <label for="serviceLineFunction">
                            Service Line/Function <span class="mandatoryMark">*</span>
                          </label>
                          <div class="form-group">
                            <select id="serviceLineFunction"
                                    class="form-control custom-select"
                                    name="serviceLineFunction"
                                    [(ngModel)]="session.serviceLineFunction"
                                    (ngModelChange)="onServiceFunctionChange($event)"
                                    #serviceLineFunction="ngModel"
                                    [ngClass]="{ 'is-invalid': f.submitted && serviceLineFunction.invalid }"
                                    [disabled]="disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')"
                                    required>
                              <option [ngValue]="null" hidden disabled selected>
                                Select
                              </option>
                              <option *ngFor="let item of dropdownData.ServiceFunctions"
                                      [attr.selected]="item.ID==session.serviceLineFunction?true:null"
                                      [attr.value]='item.ID'>
                                {{item.Name}}
                              </option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                          </div>
                        </div>
                        <div class="col-4">
                          <label for="serviceLineNA">
                            If Service Line/Function is N/A <span class="mandatoryMark">*</span>
                          </label>
                          <input id="serviceLineNA" type="text" class="form-control"
                                 name="serviceLineNA"
                                 (blur)="validateServiceLineNAValue(serviceLineNA.value)"
                                 [(ngModel)]="session.serviceLineNA" #serviceLineNA="ngModel"
                                 [ngClass]="{ 'is-invalid': f.submitted && serviceLineNA.invalid }"
                                 required
                                 [disabled]="disableServiceFunctionNA || disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <label for="sessionIndustry">
                            Industry <span class="mandatoryMark">*</span>
                          </label>
                          <div class="form-group">
                            <select id="sessionIndustry"
                                    (ngModelChange)="industryChange($event)"
                                    class="form-control custom-select" name="sessionIndustry"
                                    [(ngModel)]="session.sessionIndustry"
                                    #sessionIndustry="ngModel"
                                    [ngClass]="{ 'is-invalid': f.submitted && sessionIndustry.invalid }"
                                    [disabled]="disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')"
                                    required>
                              <option [ngValue]="null" hidden disabled selected>
                                Select
                              </option>
                              <option *ngFor="let item of dropdownData.Industries"
                                      [attr.selected]="item.ID==session.industryid?true:null"
                                      [attr.value]='item.ID'
                                      [hidden]="item.IsMDR || (!showNAFields && item.ID == 34)">
                                {{item.Name }}
                              </option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                          </div>
                        </div>
                        <div class="col-4">
                          <label for="industryNA">
                            If Industry is N/A <span class="mandatoryMark">*</span>
                          </label>
                          <input id="industryNA" type="text" class="form-control" name="industryNA"
                                 (blur)="validateIndustryNAValue(industryNA.value)"
                                 [(ngModel)]="session.industryNA" #industryNA="ngModel"
                                 [ngClass]="{ 'is-invalid': f.submitted && industryNA.invalid }"
                                 required
                                 [disabled]="disableIndustryNA || disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <label for="sessionSector">Sector <span class="mandatoryMark">*</span></label>
                          <div class="form-group">
                            <select id="sessionSector" class="form-control custom-select" name="sessionSector"
                                    [(ngModel)]="session.sessionSector"
                                    (ngModelChange)="onSectorChange($event)"
                                    #sessionSector="ngModel"
                                    [disabled]="disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')"
                                    [ngClass]="{ 'is-invalid': f.submitted && sessionSector.invalid }"
                                    required>
                              <option [ngValue]="null" hidden disabled selected>
                                Select
                              </option>
                              <option *ngFor="let item of dropdownData_Sectors"
                                      [attr.selected]="item.SectorID==session.sectorid?true:null"
                                      [attr.value]='item.SectorID'>
                                {{item.SectorName}}
                              </option>
                            </select>
                            <i class="fa fa-chevron-down"></i>
                          </div>
                        </div>
                        <div class="col-4">
                          <label for="sectorNA">If Sector is N/A <span class="mandatoryMark">*</span></label>
                          <input id="sectorNA" type="text" class="form-control" name="sectorNA"
                                 (blur)="validateSectorNAValue(sectorNA.value)"
                                 [(ngModel)]="session.sectorNA" #sectorNA="ngModel"
                                 [ngClass]="{ 'is-invalid': f.submitted && sectorNA.invalid }"
                                 required
                                 [disabled]="disableSectorNA || disableSubscriptionFields || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')" />
                        </div>
                      </div>
                    </ng-template>
                    <div class="row">
                      <div class="col-4">
                        <label for="sessionDepartment">Department <span class="mandatoryMark">*</span></label>
                        <div class="form-group">
                          <select id="sessionDepartment" class="form-control custom-select"
                                  (change)="departmentChange($event)" name="sessionDepartment"
                                  [(ngModel)]="session.sessionDepartment"
                                  #sessionDepartment="ngModel"
                                  [ngClass]="{ 'is-invalid': f.submitted && sessionDepartment.invalid }"
                                  required>
                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData.Departments"
                                    [attr.selected]="item.ID==session.departmentid?true:null"
                                    [attr.value]='item.ID'>
                              {{item.Name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                        </div>
                      </div>
                      <div class="col-4" *ngIf="!otherDepartmentDisable">
                        <label for="otherDepartment">If Other Department <span class="mandatoryMark">*</span></label>
                        <input id="otherDepartment" type="text" class="form-control" name="otherDepartment"
                               [(ngModel)]="session.otherDepartment" #otherDepartment="ngModel"
                               [ngClass]="{ 'is-invalid': f.submitted && (otherDepartment.invalid || (session.otherDepartment && session.otherDepartment?.trim() === '')) }" (ngModelChange)="generateSessionName()"
                               required [disabled]="otherDepartmentDisable" (blur)="validateOtherDepartmentTextValue(otherDepartment.value)" />
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 2 Accordian Session Details-->
          <div class="panel panel-default" id="tab2">
            <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse3')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab2')">
                <a data-bs-parent="#accordion">Session Details</a>
              </h4>
            </div>
            <div id="collapse3" class="panel-collapse collapse accordion2">
              <div class="panel-body">
                <div id="accordn2" class="col-12 sessonDetails">

                                    <div class="row">
                                        <div class="col-3" *ngIf="isSelected('Deloitte')">
                                            <label for="ppmd"># Deloitte Professionals <span class="mandatoryMark">*</span></label>
                                            <input id="ppmd" class="form-control" type="number" min="0" maxlength="9" name="ppmd"
                                                [(ngModel)]="session.ppmd" (keypress)="restrictNumeric($event)"
                                                #ppmd="ngModel"
                                                [ngClass]="{ 'is-invalid': f.submitted && ppmd.invalid }" required />
                                        </div>
                                        <div class="col-4"
                                            *ngIf="(isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience'))">
                                            <label for="nonDelProfessional">
                                                # Non-Deloitte Participants <span class="mandatoryMark">*</span>
                                            </label>
                                            <input id="nonDelProfessional" type="number" min="0" maxlength="9" class="form-control"
                                                name="nonDelProfessional" [(ngModel)]="session.nonDelProfessional"
                                                (focusout)="calculateChargebackAndSurcharge()"
                                                (keypress)="restrictNumeric($event)" #nonDelProfessional="ngModel"
                                                [disabled]="disableNonDeloitteProfessional"
                                                [ngClass]="{ 'is-invalid': f.submitted && nonDelProfessional.invalid }"
                                                required />
                                        </div>
                                        <div class="col-4"
                                            *ngIf="(isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience'))">
                                            <div class="c-suite">
                                                <div>
                                                    <label for="cSuite">
                                                        Check here if there are any executive level
                                                        participants
                                                    </label>
                                                </div>
                                                <div class="c-suite-checkbox">
                                                    <input type="checkbox" id="cSuite" class="c-suite-checkbox"
                                                        name="cSuite" #cSuite="ngModel" [(ngModel)]="session.cSuite"
                                                        [checked]="isExtProfessional" (change)="onCSuiteChange($event)"
                                                        [disabled]="session.executives && session.executives > 0" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="(!isSelected('Deloitte') && session.sessionLink)">
                                        <div class="col-4 ActualUsage">
                                            <label for="actualUsage"># Actual Participants <span class="mandatoryMark">*</span></label>
                                            <input id="actualUsage" type="number" min="0" maxlength="9"
                                                class="form-control actualUsage mb5" name="actualUsage"
                                                [(ngModel)]="session.actualUsage" (keypress)="restrictNumeric($event)"
                                                #actualUsage="ngModel"
                                                [ngClass]="{ 'is-invalid': f.submitted && actualUsage.invalid }"
                                                required disabled />

                      <div class="subText-checkbox">
                        Number of non-Deloitte participants who have
                        completed the assessment using this link
                      </div>
                    </div>
                  </div>
                  <div class="row">

                    <div class="col-4">
                      <label for="sessionCountrySel">Session Country/Location <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="sessionCountrySel" class="form-control custom-select" #sessionCountry="ngModel"
                                name="sessionCountry" [(ngModel)]="session.sessionCountry"
                                (ngModelChange)="sessionCountryChange($event)"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionCountry.invalid }"
                                [disabled]="sessionId !== 0 && userRoleID == 4 && session.approvalStatus != 'Draft' "
                                required>
                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of sessionCountryMasterData"
                                  [attr.selected]="item.ID==session.countryid?true:null"
                                  [attr.value]='item.ID'>
                            {{item.Name}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>

                    <div class="col-4">
                      <label for="sessionState">Session Location (State) <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="sessionState" class="form-control custom-select" name="sessionState"
                                [(ngModel)]="session.sessionState"
                                (ngModelChange)="sessionStateChange($event)" #sessionState="ngModel"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionState.invalid }"
                                required
                                [disabled]="stateDisable || (sessionId !== 0 && userRoleID == 4  && session.approvalStatus != 'Draft')">
                          <option [ngValue]="null" hidden disabled selected>Select </option>
                          <option *ngFor="let item of dropdownData.States"
                                  [attr.selected]="item.ID==session.stateid?true:null"
                                  [attr.value]='item.ID'>
                            {{item.Name}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-4">
                      <label for="sessionCity">Closest City <span class="mandatoryMark">*</span></label>

                      <input *ngIf="stateDisable" type="text" id="sessionCity" name="sessionCity"
                             [(ngModel)]="session.sessionCity" #sessionCity="ngModel"
                             class="form-control" (blur)="validateCityTextValue(sessionCity.value)"
                             [ngClass]="{ 'is-invalid': f.submitted && sessionCity.invalid  }"
                             [disabled]="sessionId !== 0 && userRoleID == 4 && session.approvalStatus != 'Draft'"
                             required />
                      <div class="form-group" *ngIf="!stateDisable">
                        <select class="form-control custom-select" name="sessionCity"
                                [(ngModel)]="session.sessionCity" #sessionCity="ngModel"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionCity.invalid }"
                                [disabled]="sessionId !== 0 && userRoleID == 4 && session.approvalStatus != 'Draft'"
                                required>
                          <option [ngValue]="null" hidden disabled selected>Select </option>
                          <option *ngFor="let item of cityList"
                                  [attr.selected]="item.CityID==session.sessionCity?true:null"
                                  [attr.value]='item.CityID'>
                            {{item.CityName}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <label for="sessionTypes">Session Type <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="sessionTypes" class="form-control custom-select" name="sessionTypes"
                                [(ngModel)]="session.sessionTypes" #sessionTypes="ngModel"
                                (ngModelChange)="onSelectSessionType($event, true);resetInvalidAge();resetSelectedFacilitator();onOpenChargeCodeAccordian();"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionTypes.invalid }"
                                [disabled]="staticSessionTypeFlag  ||(sessionId !== 0 && session.approvalStatus != 'Draft' &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3) ||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4|| userRoleID==5 || userRoleID==6 || userRoleID==2 || userRoleID==8) )|| (!session.subscriptionId && userRoleID ==4))))) ||(eventName!='' && eventName!=null) || (statusChanges && userRoleID != 1 && userRoleID != 3)"
                                required>
                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of dropdownData.SessionType"
                                  [attr.selected]="item.SessionTypeID==session.sessionTypes?true:null"
                                  [attr.value]='item.SessionTypeID' [title]="item.ToolTip">
                            {{item.SessionTypeName}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                    <div class="col-4" *ngIf="showSessionSubType">
                      <label for="sessionSubTypes">Session SubType <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="sessionSubTypes" class="form-control custom-select" name="sessionSubTypes"
                                [(ngModel)]="session.sessionSubTypes" #sessionSubTypes="ngModel"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionSubTypes.invalid }"
                                [disabled]="staticSessionTypeFlag
                                                        || (sessionId !== 0 && session.approvalStatus != 'Draft'
                                                        &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3)
                                                        ||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4 || userRoleID==5 || userRoleID==6) )|| (!session.subscriptionId && userRoleID ==4))))) ||(eventName!='' && eventName!=null) || (statusChanges && userRoleID != 1 && userRoleID != 3)"
                                (ngModelChange)="onChangeOfSessionSubType($event);resetInvalidAge()"
                                required>
                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of dropdownData.SessionSubType"
                                  [attr.selected]="item.SessionSubTypeID ==session.sessionSubTypes?true:null"
                                  [attr.value]='item.SessionSubTypeID'>
                            {{item.SessionSubTypeName}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>

                    <div class="col-4" *ngIf="showEvent">
                      <label for="sessionTypesEvent">Event <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="sessionTypesEvent" class="form-control custom-select" name="sessionTypesEvent"
                                [(ngModel)]="session.sessionTypesEvent" #sessionTypesEvent="ngModel"
                                (ngModelChange)="onSelectSessionTypesEvent($event);enableContentArea();resetSelectedFacilitator();onOpenChargeCodeAccordian();"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionTypesEvent.invalid }"
                                [disabled]="staticSessionTypeFlag
                                                        || (sessionId !== 0 && session.approvalStatus != 'Draft'
                                                        &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3)
                                                        ||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4 || userRoleID==5 || userRoleID==6) )|| (!session.subscriptionId && userRoleID ==4))))) || (eventName!='' && eventName!=null) || (statusChanges && userRoleID != 1 && userRoleID != 3)"
                                required>
                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of dropdownData.SessionTypeEvents"
                                  [attr.selected]="item.eventID ==session.sessionTypesEvent?true:null"
                                  [attr.value]='item.eventID'>
                            {{item.Name}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>

                    <div class="col-4" *ngIf="showProgram">
                      <label for="sessionTypesProgram">Program <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="sessionTypesProgram" class="form-control custom-select" name="sessionTypesProgram"
                                [(ngModel)]="session.sessionTypesProgram"
                                #sessionTypesProgram="ngModel"
                                (ngModelChange)="onSelectSessionTypesProgram($event)"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionTypesProgram.invalid }"
                                [disabled]="staticSessionTypeFlag
                                                        || (sessionId !== 0 && session.approvalStatus != 'Draft'
                                                        &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3)
                                                        ||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4 || userRoleID==5 || userRoleID==6) )|| (!session.subscriptionId && userRoleID ==4))))) || (eventName!='' && eventName!=null) || !showProgramFinance || (statusChanges && userRoleID != 1 && userRoleID != 3)"
                                required>
                          <!--required-->
                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of dropdownData.EventPrograms"
                                  [attr.selected]="item.programID==session.sessionTypesProgram?true:null"
                                  [attr.value]='item.programID'>
                            {{item.Name}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                    <div class="col-4" *ngIf="showSpecify">
                      <label for="sessionTypeSpecifyInput">
                        {{specifyLabel}} <span class="mandatoryMark"
                                               *ngIf="isSubTypeMandatory">*</span>
                      </label>
                      <input id="sessionTypeSpecifyInput" type="text" value={{session.sessionTypeSpecify}}
                             name="sessionTypeSpecify" [(ngModel)]="session.sessionTypeSpecify"
                             (change)="checkPleaseSpecifyLength($event)" (blur)="validatesessionTypeSpecifyValue(sessionTypeSpecify.value)"
                             #sessionTypeSpecify="ngModel" class="form-control"
                             [ngClass]="{ 'is-invalid': f.submitted && sessionTypeSpecify.invalid }"
                             [disabled]="staticSessionTypeFlag
                                                        || (sessionId !== 0 && session.approvalStatus != 'Draft'
                                                        &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3)
                                                        ||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4|| userRoleID==5 || userRoleID==6) )|| (!session.subscriptionId && userRoleID ==4))))) || (eventName!='' && eventName!=null) || (statusChanges && userRoleID != 1 && userRoleID != 3)"
                                               [required]="isSubTypeMandatory" />
                                      </div>
                                      <!--program audit lab subtype-->
                                      <div class="col-4" *ngIf="showAuditLabSubType">
                                        <label for="sessionTypeSpecify">
                                          {{specifyLabel}} <span class="mandatoryMark"
                                                                 *ngIf="isSubTypeMandatory">*</span>
                                        </label>
                                        <div class="form-group">
                                          <select id="sessionTypeSpecify" class="form-control custom-select" name="sessionTypeSpecify"
                                                  [(ngModel)]="session.sessionTypeSpecify"
                                                  #sessionTypeSpecify="ngModel"
                                                  (ngModelChange)="ProgramSpecificationLength($event)"
                                                  [ngClass]="{ 'is-invalid': f.submitted && sessionTypeSpecify.invalid }"
                                                  required>
                                            <!--required-->
                                            <option [ngValue]="''" hidden disabled selected>Select</option>
                                            <option *ngFor="let item of dropdownData.ProgramSpecification"
                                                    [attr.selected]="item.Name==session.sessionTypeSpecify?true:null"
                                                    [attr.value]='item.Name'>
                                              {{item.Name}}
                                            </option>
                                          </select>
                                          <i class="fa fa-chevron-down"></i>
                                        </div>
                                      </div>
                                      <div class="col-4" *ngIf="showProBono">
                                        <div class="proBonoRadios">
                                          <div [ngClass]="{'showError': f.submitted && !session.proBono}">
                                            <label>
                                              Are you offering this session pro-bono?<span class="mandatoryMark" *ngIf="isSubTypeMandatory">*</span>
                                            </label>
                                            <div [ngClass]="{  }">
                                              <input type="radio" name="proBono"
                                                     [(ngModel)]="session.proBono" value="yes" id="pro-bono-yes"
                                                     (click)="onProbonoCheck('yes');enableContentArea(); "
                                                     [required]="showProBono && !session.proBono"
                                                     [disabled]=" sessionProBonoFlag ||staticSessionTypeFlag || (sessionId !== 0 && session.approvalStatus != 'Draft' &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3)||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4|| userRoleID==5 || userRoleID==6))|| (!session.subscriptionId && userRoleID ==4))))) ||  (eventName!='' && eventName!=null) || (statusChanges && userRoleID != 1 && userRoleID != 3)">
                                              <label for="pro-bono-yes">Yes</label>&nbsp;&nbsp;
                                              <input type="radio" name="proBono"
                                                     [(ngModel)]="session.proBono" value="no" id="pro-bono-no"
                                                     (click)="onProbonoCheck('no');enableContentArea();updatePleaseSpecifyLength();"
                                                     [disabled]="sessionProBonoFlag ||staticSessionTypeFlag || (sessionId !== 0 && session.approvalStatus != 'Draft' &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3)|| (session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4||  userRoleID==5 || userRoleID==6))|| (!session.subscriptionId && userRoleID ==4))))) ||  (eventName!='' && eventName!=null) || (statusChanges && userRoleID != 1 && userRoleID != 3)"
                                                     [required]="showProBono && !session.proBono"> <label for="pro-bono-no">No</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-4" *ngIf="proBonoYes">
                                        <label for="explainRationale">
                                          If pro-bono, please explain rationale <span class="mandatoryMark"
                                                                                      *ngIf="isSubTypeMandatory">*</span>
                                        </label>
                                        <textarea id="explainRationale" type="text" name="explainRationale"
                                               value={{session.explainRationale}}
                                               (change)="checkPleaseSpecifyLength($event)"
                                               [(ngModel)]="session.explainRationale" #explainRationale="ngModel"
                                               class="form-control" (blur)="validateProbonoTextValue(explainRationale.value)"
                                               [ngClass]="{ 'is-invalid': f.submitted && explainRationale.invalid }"
                                               [disabled]="staticSessionTypeFlag
                                                        || (sessionId !== 0 && session.approvalStatus != 'Draft'
                                                        &&((session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3)
                                                        ||(session.approvalStatus == 'Approval Pending' && ((session.subscriptionId &&(userRoleID ==4 || userRoleID==5 || userRoleID==6) )|| (!session.subscriptionId && userRoleID ==4))))) || (eventName!='' && eventName!=null) || (statusChanges && userRoleID != 1 && userRoleID != 3)"
                             [required]="isSubTypeMandatory" ></textarea>
                    </div>
                    <div class="col-4"
                         *ngIf="(session.sponsoredCountry == 23) && (isSelected('ExternalClient') || isSelected('ExternalNonClient') ) && (((session.sessionTypes =='13') && (session.sessionSubTypes == '3' || session.sessionSubTypes == '2' )) || ((session.sessionTypes =='20') && (session.sessionSubTypes == '6' || session.sessionSubTypes == '7' )) || (session.sessionTypes =='14' || session.sessionTypes =='21') )">
                      <div class="ageGroup">
                        <div>
                          <label for="InvalidAge">
                            Are any of the participants under the age of 18?
                          </label>
                        </div>
                        <div class="ageGroup-checkbox">
                          <input type="checkbox" id="InvalidAge" class="ageGroupCheckbox"
                                 name="InvalidAge" [disabled]="InvalidAgeDisabled"
                                 [checked]="InvalidAge" [(ngModel)]="InvalidAge"
                                 InvalidAge="ngModel" (change)="onSelectInvalidAge($event)" />

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!--start of content type-->
                    <div class="col-4">
                      <label for="contentArea">Content Area <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="contentArea" class="form-control custom-select" name="contentArea"
                                [(ngModel)]="session.contentArea" #contentArea="ngModel"
                                [disabled]="disableContentArea"
                                (ngModelChange)="onContentChange();resetSelectedFacilitator()"
                                [ngClass]="{ 'is-invalid': f.submitted && contentArea.invalid }"
                                required>
                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of dropdownData.ContentArea"
                                  [attr.selected]="item.ID==session.contentArea?true:null"
                                  [attr.value]='item.ID'>
                            {{item.ContentAreaName}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                    <!--end of content type-->
                    <!--start of topic-->
                    <div class="col-4"
                         *ngIf="session.contentArea == 2">
                      <label for="topicSelect">Topic <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="topicSelect" class="form-control custom-select" name="Topic"
                                [(ngModel)]="session.Topic" #Topic="ngModel"
                                (ngModelChange)="resetSelectedFacilitator()"
                                [disabled]="session.contentArea != 2"
                                [ngClass]="{ 'is-invalid': f.submitted && Topic.invalid }" required>
                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of dropdownData.Topic"
                                  [attr.selected]="item.ID==session.Topic?true:null"
                                  [attr.value]='item.ID'>
                            {{item.TopicName}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                    <!--end of topic-->
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <label for="sessionFormat">Session Format <span class="mandatoryMark">*</span></label>
                      <div class="form-group">
                        <select id="sessionFormat" class="form-control custom-select" name="sessionFormat"
                                [(ngModel)]="session.sessionFormat" #sessionFormat="ngModel"
                                [disabled]="disableSesionFormat || (session.approvalStatus == 'Approval Pending' && ((userRoleID == 2) || (userRoleID == 8) || (userRoleID == 5 && session.subscriptionId ) )) || (session.approvalStatus != 'Draft' && sessionId !== 0 && (session.approvalStatus == 'Approved' || userRoleID == 4) && (userRoleID != 1 && userRoleID != 3 ))"
                                [ngClass]="{ 'is-invalid': f.submitted && sessionFormat.invalid }"
                                required>

                          <option [ngValue]="null" hidden disabled selected>Select</option>
                          <option *ngFor="let item of dropdownData.SessionFormat"
                                  [attr.selected]="item.SessionFormatID==session.sessionFormat?true:null"
                                  [attr.value]='item.SessionFormatID' [title]="item.ToolTip"
                                  [hidden]="item?.SessionFormatID == 3 && (userRoleID != 5 && userRoleID != 1)">
                            {{item.SessionFormatName}}
                          </option>
                        </select>
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="row">
                        <div class="col-4">
                          <label for="sessionDate">Session Date <span class="mandatoryMark">*</span></label>
                          <div class="form-group"
                               [ngClass]="{'disabled':session.approvalStatus != 'Draft' && sessionId !== 0 && (userRoleID == 4 || (session.approvalStatus == 'Approved' && userRoleID == 5 && session.subscriptionId) || (session.approvalStatus == 'Approved' && (userRoleID == 2 || userRoleID == 8 || userRoleID == 6))) }">
                            <div class="input-group">
                              <input id="sessionDate" (ngModelChange)="onDateChange($event)"
                                     class="form-control" placeholder="mm-dd-yyyy"
                                     [minDate]="minimumDate" [maxDate]="maximumDate"
                                     (click)="d.toggle()" [(ngModel)]="session.sessionDate"
                                     #sessionDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                                     name="sessionDate" dateFormat="mm-dd-yyyy"
                                     [ngClass]="{ 'is-invalid': (f.submitted && sessionDate.invalid) || InvalidSessionDate }"
                                     (focusout)="onFocusoutSessionDate(session.sessionDate)"
                                     required readonly>
                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar"
                                        (click)="d.toggle()" type="button">
                                  <i class="fa fa-calendar"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <p *ngIf="InvalidSessionDate" class="text-red">
                            Session date should
                            be within subscription date range
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 3 Accordian Chargebacks/Fees-->
          <div class="panel panel-default"
               [hidden]="(isSelected('Deloitte') || ((userRoleID != 1 && userRoleID != 3) && (session.sponsoredCountry != 23 || (session.sessionTypes != 8 && session.sessionTypes != 16 && session.sessionTypes != 24 && session.sessionTypes != 33 && session.sessionTypes != 34 && session.sessionTypes != 35 && !((session.sessionTypes == 13 && session.sessionSubTypes != 2) || (session.sessionTypes == 20 && session.sessionSubTypes != 6)) && this.session.sessionTypesEvent != 17 && this.session.sessionTypesEvent != 18 && this.session.sessionTypesEvent != 19 ))))"
               id="tab3">
            <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse5')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab3')">
                <a data-bs-parent="#accordion">
                  Chargebacks/Fees
                </a>
              </h4>
            </div>
            <div id="collapse5" class="panel-collapse collapse accordion3">
              <div class="panel-body accordianSection">

                <div class="row" *ngIf="isSelected('Deloitte')">
                  <div class="col-2">
                    <label for="currencyTypeTop">Currency type</label>
                    <div class="form-group">
                      <select id="currencyTypeTop" class="form-control custom-select" name="currencyType"
                              [(ngModel)]="session.currencyType" #currencyType="ngModel"
                              [disabled]="session.sponsoredCountry == 23 || isSessionCreatedFromCommercialization || isDUClientEvent"
                              [required]="session.gxFees > 0 || session.surcharge > 0"
                              [ngClass]="{ 'is-invalid': f.submitted && currencyType.invalid }">
                        <option value=4>USD ($)</option>
                        <option value=5>AUD ($)</option>
                        <option value=3>CAD ($)</option>
                        <option value=1>EUR (€)</option>
                        <option value=2>GBP (£)</option>
                      </select>
                      <i class="fa fa-chevron-down"></i>
                    </div>
                  </div>
                  <div class="col-2">
                    <label for="chargebackTop">Chargeback</label>
                    <input id="chargebackTop" type="number" class="form-control"
                           (keypress)="validateChargeBackFields($event)" name="gxFees"
                           [(ngModel)]="session.gxFees" #gxFees="ngModel"
                           [disabled]="(userRoleID != 1 || chargebackDisabledFlag || isSessionCreatedFromCommercialization || isDUClientEvent) && !(this.session.subscriptionId && !this.subscriptionIDError && !this.isSubscriptionStatusError)" />
                  </div>
                </div>
                <div class="row" *ngIf="!isSelected('Deloitte')">
                  <div class="col-2"
                       [hidden]="((userRoleID != 1 && userRoleID != 3) && (session.sponsoredCountry != 23 || (session.sessionTypes != 8 && session.sessionTypes != 16 && session.sessionTypes != 24 && session.sessionTypes != 33 && session.sessionTypes != 34 && session.sessionTypes != 35 && session.sessionTypes != 13 && session.sessionTypes != 20 && session.sessionTypes != 14 && session.sessionTypes != 21 && session.sessionTypes != 15 && session.sessionTypes != 30 && session.sessionTypes != 23 && this.session.sessionTypesEvent != 17 && this.session.sessionTypesEvent != 18 && this.session.sessionTypesEvent != 19 )))">
                    <label for="currencyTypeGx">Currency type </label>
                    <div class="form-group">
                      <select id="currencyTypeGx" class="form-control custom-select" name="currencyType"
                              [(ngModel)]="session.currencyType" #currencyType="ngModel"
                              [disabled]="session.sponsoredCountry == 23 || isSessionCreatedFromCommercialization || isDUClientEvent"
                              [required]="session.gxFees > 0 || session.surcharge > 0"
                              [ngClass]="{ 'is-invalid': f.submitted && currencyType.invalid }">
                        <option value=4>USD ($)</option>
                        <option value=5>AUD ($)</option>
                        <option value=3>CAD ($)</option>
                        <option value=1>EUR (€)</option>
                        <option value=2>GBP (£)</option>
                      </select>
                      <i class="fa fa-chevron-down"></i>
                    </div>
                  </div>
                  <div class="col-2">
                    <ng-container *ngIf="(!(userRoleID != 1 && userRoleID != 3) && (session.sponsoredCountry != 23 || (session.sessionTypes != 8 && session.sessionTypes != 16 && session.sessionTypes != 24 && session.sessionTypes != 33 && session.sessionTypes != 34 && session.sessionTypes != 35 && session.sessionTypes != 13 && session.sessionTypes != 20 && session.sessionTypes != 14 && session.sessionTypes != 21 && session.sessionTypes != 15 && session.sessionTypes != 30 && session.sessionTypes != 23 && this.session.sessionTypesEvent != 6 && this.session.sessionTypesEvent != 10 && this.session.sessionTypesEvent != 14 )) || !((sessionId != 0 && session.subscriptionId && (userRoleID == 2 || userRoleID == 8 || userRoleID == 4 || ((userRoleID == 5 || userRoleID == 6 ) && session.approvalStatus == 'Approved') ) && !session.gxFees) || (userRoleID == 3 && sessionId != 0 && session.subscriptionId  && session.sponsoredCountry == 23 &&  !session.gxFees && session.approvalStatus == 'Approved')))">
                      <label for="chargebackfees">Chargeback</label>
                      <input id="chargebackfees" type="number" class="form-control marB5"
                             (keypress)="validateChargeBackFields($event)" name="gxFees"
                             [(ngModel)]="session.gxFees" #gxFees="ngModel"
                             [disabled]="(isDUClientEvent || isFLPEvent || chargebackDisabledFlag || !isExistingSession && session.sponsoredCountry == 23 && (session.sessionTypes == 8 || session.sessionTypes == 16 || session.sessionTypes == 24 || session.sessionTypes == 33 || session.sessionTypes == 34 || session.sessionTypes == 35  || session.sessionTypes == 13 || session.sessionTypes == 20 || session.sessionTypes == 14 || session.sessionTypes == 21 || session.sessionTypes == 15 || session.sessionTypes == 30 || session.sessionTypes == 23 || (this.session.sessionTypes == 11 && this.session.sessionTypesEvent == 6) || (this.session.sessionTypes == 19 && this.session.sessionTypesEvent == 10) || (this.session.sessionTypes == 26 && this.session.sessionTypesEvent == 14)) || isSessionCreatedFromCommercialization) && (!(this.session.subscriptionId && !this.subscriptionIDError && !this.isSubscriptionStatusError) || (userRoleID != 1 && userRoleID != 3)) || (session.approvalStatus == 'Approved' && userRoleID != 1 && userRoleID != 3) || (userRoleID == 3 && sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  session.gxFees && session.approvalStatus == 'Approved') || (eventName!='' && eventName!=null) " />
                      <div *ngIf="!isSelected('Deloitte')" class="subText-checkbox">
                        Based on estimated
                        number of non-Deloitte participants
                      </div>
                    </ng-container>
                    <ng-container *ngIf="session.surcharge && (userRoleID == 1  || (userRoleID == 3 && !(sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  !session.surcharge && session.approvalStatus == 'Approved')) || showSurchargefieldForFacAndCor )">
                      <label for="surchargeGx">Surcharge </label>
                      <input id="surchargeGx" type="number" class="form-control mb5"
                             [ngClass]="{'negative-surcharge' : session.surcharge < 0 }"
                             (keypress)="validateChargeBackFields($event)"
                             (change)="onChangeSurcharge()" name="surcharge"
                             [(ngModel)]="session.surcharge" #surcharge="ngModel"
                             [disabled]="((disableSurcharge || myFlag || isSessionCreatedFromCommercialization || isDUClientEvent) && !(this.session.subscriptionId && !this.subscriptionIDError && !this.isSubscriptionStatusError)) || (disableSurcharge && (this.session.subscriptionId && !this.subscriptionIDError && !this.isSubscriptionStatusError)) || (userRoleID == 3 && session.approvalStatus == 'Approved' && (sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  session.surcharge)) || (eventName!='' && eventName!=null) || (isFLPEvent && !session.rate && session.sponsoredCountry == 23)" />
                      <div class="subText-checkbox" *ngIf="session.sessionLink">
                        Based on actual number
                        of non-Deloitte participants
                      </div>
                    </ng-container>
                  </div>
                  <div class="col-3"
                       *ngIf="(userRoleID == 1 || (userRoleID == 3 && !(sessionId != 0 && session.subscriptionId &&session.sponsoredCountry == 23 &&  !session.rate && session.approvalStatus == 'Approved')) || showRatefieldForFacAndCor )">
                    <label for="perPersonRate">Per person rate if non-standard</label>
                    <input id="perPersonRate" type="number" min="0" class="form-control"
                           (focusout)="calculateChargebackAndSurcharge()"
                           (keypress)="validateChargeBackFields($event, true)" name="rate"
                           [(ngModel)]="session.rate" #rate="ngModel"
                           [disabled]="((disableRate || myFlag || isSessionCreatedFromCommercialization || isDUClientEvent) && !(this.session.subscriptionId && !this.subscriptionIDError && !this.isSubscriptionStatusError && (userRoleID == 1 || userRoleID == 3))) ||  ((userRoleID == 2  || userRoleID == 8  || userRoleID == 4) && session.approvalStatus=='Approval Pending') || (userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  session.rate ))" />
                  </div>
                  <div class="col-3"
                       *ngIf="(userRoleID == 1  || (userRoleID == 3 && !(sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  !session.reason && session.approvalStatus == 'Approved')) || (session.approvalStatus === 'Approval Pending' && userRoleID != 5 && userRoleID != 6 && !(sessionId != 0 && session.subscriptionId && (userRoleID == 2 || userRoleID == 8 || userRoleID == 4 ) && !session.reason)) )">
                    <label for="nonStandardReason">Reason</label>
                    <input id="nonStandardReason" type="text" class="form-control" name="reason"
                           [(ngModel)]="session.reason" #reason="ngModel"
                           [disabled]="(isFLPEvent && !session.rate && session.sponsoredCountry == 23) || myFlag || isSessionCreatedFromCommercialization || ((userRoleID == 2  || userRoleID == 8 || userRoleID == 4) && session.approvalStatus=='Approval Pending') || (userRoleID == 3 && session.approvalStatus == 'Approved' && (sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  session.reason ))  " />
                  </div>
                  <div class="col-2" *ngIf="session.approvalStatus != 'New' && userRoleID == 1">
                    <ng-container *ngFor="let sfdcEvent of sfdcEvents; let i = index">
                      <label for="{{'event-' + i}}">
                        Event Name
                        <ng-container *ngIf="sfdcEvents[i]?.eventName">
                          <a href="{{sfdcEvents[i].eventUrl}}" target="_blank" class="ml-2">
                            <i class="fa fa-external-link"></i>
                          </a>
                        </ng-container>
                        <ng-container *ngIf="!sfdcEvents[i]?.eventName">
                          <i class="fa fa-external-link ml-2 anchorColor"></i>
                        </ng-container>
                      </label>
                      <input type="text" class="form-control" id="{{'event-' + i}}"
                             name="{{'event-' + i}}" [(ngModel)]="sfdcEvents[i].eventName"
                             [disabled]="userRoleID != 1 || !!sfdcEvents[i].eventId || session.approvalStatus != 'Approved' || !session.disableSFDCIntegration" />
                    </ng-container>
                  </div>
                  <!-- If sesion is new event field should be disabled -->
                  <div class="col-2" *ngIf="session.approvalStatus == 'New' && userRoleID == 1">
                    <label for="event-0">
                      Event Id
                      <i class="fa fa-external-link ml-2 anchorColor"></i>
                    </label>
                    <input type="text" class="form-control" id="event-0" name="event-0" disabled />
                  </div>
                </div>
                <div class="row"
                     *ngIf="!isSelected('Deloitte') && !session.subscriptionId && userRoleID == 1 && !doNotIntegrateWithSalesforce &&
                                                   (sessionId !== 0 && (session.approvalStatus == 'Approved' ||
                                                   session.approvalStatus == 'To Review' || session.approvalStatus == 'Cancelled' ||
                                                   session.approvalStatus == 'Not Approved' || session.approvalStatus =='Approval Pending'))">
                                    <div class="col-4 disableSFDC">
                                        <label for="disableSFDCIntegration">Do not integrate with Salesforce</label>
                                        <input [(ngModel)]="session.disableSFDCIntegration" id="disableSFDCIntegration"
                                            type="checkbox" name="disableSFDCIntegration">
                                    </div>
                                    <div class="col-3" *ngIf="session.disableSFDCIntegration">
                                        <label for="">Reason <span class="mandatoryMark">*</span></label>
                                        <div class="form-group">
                                            <select class="form-control custom-select" name="sfdcDisableReasonId"
                                                [(ngModel)]="session.sfdcDisableReasonId" #sfdcDisableReasonId="ngModel"
                                                [ngClass]="{ 'is-invalid': f.submitted && sfdcDisableReasonId.invalid }"
                                                required>
                                                <option [value]="null" hidden disabled selected>Select</option>
                                                <option *ngFor="let sfdcDisableReason of sfdcDisableReasons"
                                                    [value]="sfdcDisableReason.ID">
                                                    {{sfdcDisableReason.Reason}}
                                                </option>
                                            </select>
                                            <i class="fa fa-chevron-down"></i>
                                        </div>
                                    </div>
                                    <div class="col-3 disableSFDCOtherReason">
                                        <ng-container
                                            *ngIf="session.disableSFDCIntegration && session.sfdcDisableReasonId == 4">
                                            <input type="text" class="form-control"
                                                [(ngModel)]="session.sfdcDisableOtherReason"
                                                (focusout)="onFocusOutOtherReason()"
                                                (ngModelChange)="validateSFDCDisableOtherReason()"
                                                name="sfdcDisableOtherReason" #sfdcDisableOtherReason="ngModel"
                                                [ngClass]="{ 'is-invalid': f.submitted && (sfdcDisableOtherReason.invalid || isSFDCDisableOtherReasonInvalid) }"
                                                required />
                                            <span class="invalidMessage"
                                                *ngIf="f.submitted && (!session?.sfdcDisableOtherReason || isSFDCDisableOtherReasonInvalid)">{{sfdcDisableOtherReasonInvalidMessage}}</span>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 4 Accordian Charge Codes-->
                    <div id="tab4" class="panel panel-default"
                        [hidden]="(((userRoleID != 1 && userRoleID != 3) && (session.sponsoredCountry != 23 || (session.sessionTypes != 8 && session.sessionTypes != 16 && session.sessionTypes != 24 && session.sessionTypes != 33 && session.sessionTypes != 34 && session.sessionTypes != 35 && !((session.sessionTypes == 13 && session.sessionSubTypes != 2) || (session.sessionTypes == 20 && session.sessionSubTypes != 6))  && this.session.sessionTypesEvent != 17 && this.session.sessionTypesEvent != 18 && this.session.sessionTypesEvent != 19 )))) || (isSelected('Deloitte'))">
                        <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse6')">
                            <h4 class="panel-title" (click)="ScrollIntoView('#tab4')">
                                <a (click)="onOpenChargeCodeAccordian()" data-bs-parent="#accordion">Charge Codes</a>
                            </h4>
                        </div>
                        <div id="collapse6" class="panel-collapse collapse accordion4">
                          <div class="panel-body accordianSection sessonDetails">
                            <div id="accordn4" class="row">
                              <div class=" wbsCodes" [ngClass]="multipleWBS.length > 1 ? 'col-9' : 'col-3'"
                                   *ngIf="isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience')">
                                <label> WBS <span class="mandatoryMark" *ngIf="isWBSMandatory && !session.disableSFDCIntegration && !wbsDisable">*</span></label>
                                <div class="row session-margin4" id="multiplWBS"
                                     *ngFor="let item of multipleWBS; let i = index;">
                                  <div [ngClass]="multipleWBS.length > 1 ? 'col-4' : 'col-12'" class="position-relative">
                                    <div class="wbs-input-wrapper">
                                      <input id="wbs_{{item.id}}" placeholder="WBS"
                                             class="form-control marB1 textTransform" type="text"
                                             name="wbsPrdCode_{{i}}"
                                             [ngbTypeahead]="searchWBS"
                                             [resultFormatter]="formatWBS"
                                             [inputFormatter]="formatWBS"
                                             (selectItem)="onWBSSelect($event, item.id)"
                                             (input)="onWBSCodeChange($event, item.id)"
                                             (focus)="activeWBSItemId = item.id"
                                             (focusout)="validateWBSCode(item)"
                                             [(ngModel)]="item.wbsCode"
                                             [ngClass]="{'is-invalid': (wbsid == item.id) || (item.isWbsStatusChecked && item.isWbsActive === false) || (invalidWBSDunsID && wbsid == item.id) || (f.submitted && isWBSMandatory &&  !session.disableSFDCIntegration && !isWBSFieldDisabled(item) && (!item.wbsCode || item.wbsCode.trim() === ''))}"
                                             [required]="isWBSMandatory && !session.disableSFDCIntegration && !wbsDisable && !isWBSFieldDisabled(item)"
                                             [disabled]="isWBSFieldDisabled(item)" />
                                      <span *ngIf="searchingWBS && activeWBSItemId === item.id" class="wbs-loading-spinner">
                                        <i class="fa fa-spinner fa-spin"></i> Searching...
                                      </span>
                                      <span *ngIf="shouldShowWbsSuccessIcon(item)"
                                            class="wbs-success-icon"
                                            [ngClass]="{'wbs-success-icon--inactive': shouldShowInactiveWbsSuccessIcon(item)}">
                                        <i class="fa fa-check-circle"></i>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="row" *ngIf="multipleWBS.length > 1">
                                      <div class="col-11">
                                        <input id="wbsSpecifyId_{{i}}"
                                               placeholder="Specify the percentage to charge to each code" class="form-control" type="number"
                                               name="wbsSpecifyName_{{i}}" value="{{item.wbsPercentage}}"
                                               (keyup)="onWBSPercentageChange($event, item.id)"
                                               [ngClass]="{'is-invalid': (!item.wbsPercentage || wbsError) && f.submitted}"
                                               [disabled]="!disableWbsPercentage && (isSessionCreatedFromCommercialization || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved') || (sessionId !== 0 && session.approvalStatus == 'Approved' && session.subscriptionId && (userRoleID!=1 && userRoleID!=3)) || (eventName!='' && eventName!=null) || (userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23)))" />
                                      </div>
                                      <div class="col-1 percentageSign">%</div>
                                    </div>
                                  </div>
                                  <div class="col-2">
                                    <div [hidden]="i == 0" class="removeWBS"
                                         (click)="!(!isInputWbsChanged && item.wbsCode && item.wbsCode.trim() !== '' && (isSessionCreatedFromCommercialization || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')  ||  (sessionId !== 0 && session.approvalStatus == 'Approved' && session.subscriptionId && multipleWBS.length>=1 && (userRoleID!=1 && userRoleID!=3)) || (eventName!='' && eventName!=null) || (userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  multipleWBS.length>=1 )))) && updateWBSFields('delete',item.id)">
                                      Remove
                                    </div>
                                  </div>
                                </div>
                                <div class="pad0" [ngClass]="multipleWBS.length > 1 ? 'col-4' : 'col-12'">
                                  <span id="wbs_info_text" [class.wbs-info-shifted]="searchingWBS">Enter a chargeable 22- character code (e.g., ZYW12345-01-01-01-0000). New code(s) may take few hours to appear; save as draft and retry later.</span>
                                  <!--<div class="invalidMessage"
             *ngIf="f.submitted && isWBSMandatory && multipleWBS[0] && (!multipleWBS[0].wbsCode || multipleWBS[0].wbsCode.trim() === '')">
            WBS is required.
        </div>-->
                                </div>

                                <div>


                                  <button type="button"
                                          [ngClass]="{'disabled':  ((totalWBSPercentage >= 100 || disableAddWBS || invalidWBS || isSessionCreatedFromCommercialization || (!isInputWbsChanged && (isSessionCreatedFromCommercialization || (sessionId !== 0 && userRoleID == 4 && session.approvalStatus == 'Approved')  || (sessionId !== 0 && session.approvalStatus == 'Approved' && session.subscriptionId && multipleWBS.length>=1 && (userRoleID!=1 && userRoleID!=3)) || (eventName!='' && eventName!=null) || (userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 &&  multipleWBS.length>=1 )))) ))}"
                                          class="addWBSClass"
                                          (click)="$event.preventDefault();updateWBSFields( 'add')">
                                    Add
                                    WBS
                                  </button>

                                </div>
                              </div>

                            </div>

                            <div class="row">
                              <div class=" wbsCodes"
                                   [ngClass]="multipleWBSForSurcharge.length > 1 ? 'col-9' : 'col-3'"
                                   *ngIf="showSurchargeWBS">
                                <label>Surcharge</label>

                                <div class="row" id="multiplWBSForSurcharge"
                                     *ngFor="let item of multipleWBSForSurcharge; let i = index;">
                                  <div [ngClass]="multipleWBSForSurcharge.length > 1 ? 'col-4' : 'col-12'" class="position-relative">
                                    <div class="wbs-input-wrapper">
                                      <input id="wbsSurcharge_{{item.id}}" placeholder="WBS"
                                             class="form-control textTransform" type="text"
                                             name="wbsPrdCodeForSurcharge_{{i}}"
                                             [ngbTypeahead]="searchWBSSurcharge"
                                             [resultFormatter]="formatWBS"
                                             [inputFormatter]="formatWBS"
                                             (selectItem)="onWBSSelectForSurcharge($event, item.id)"
                                             (input)="onWBSCodeChangeForSurcharge($event, item.id)"
                                             (focus)="activeSurchargeWBSItemId = item.id"
                                             (focusout)="validateWBSCodeForSurcharge()"
                                             [(ngModel)]="item.wbsCode"
                                             [disabled]="((!item.isNewSurchargeCode && (!session.surcharge || session.surcharge < 0 || isSessionCreatedFromCommercialization || (userRoleID!=1 && userRoleID!=3 && item.wbsCode )||(eventName!='' && eventName!=null && !enableSurchargeWBS) || (userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 && item.wbsCode ))))||wbsDisable)"
                                             [ngClass]="{'is-invalid': (wbsidForSurcharge == item.id) || (item.isWbsStatusChecked && item.isWbsActive === false)}" />
                                      <span *ngIf="searchingWBSSurcharge && activeSurchargeWBSItemId === item.id" class="wbs-loading-spinner">
                                        <i class="fa fa-spinner fa-spin"></i> Searching...
                                      </span>
                                      <span *ngIf="shouldShowWbsSuccessIconForSurcharge(item)"
                                            class="wbs-success-icon"
                                            [ngClass]="{'wbs-success-icon--inactive': shouldShowInactiveWbsSuccessIconForSurcharge(item)}">
                                        <i class="fa fa-check-circle"></i>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="row" *ngIf="multipleWBSForSurcharge.length > 1">
                                      <div class="col-11">
                                        <input id="wbsSpecifyIdForSurcharge_{{i}}"
                                               placeholder="Specify the percentage to charge to each code" class="form-control" type="number" name="wbsSpecifyNameForSurcharge_{{i}}"
                                               value="{{item.wbsPercentage}}"
                                               (keyup)="onWBSPercentageChangeForSurcharge($event, item.id)"
                                               [disabled]="!disableSurchargePercentage && (!session.surcharge || session.surcharge < 0 || isSessionCreatedFromCommercialization || (userRoleID!=1 && userRoleID!=3 && item.wbsPercentage ) || (eventName!='' && eventName!=null && !enableSurchargeWBS) || (sessionId !== 0 && session.approvalStatus == 'Approved' && session.subscriptionId && (userRoleID!=1 && userRoleID!=3)) ||(userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23 && item.wbsPercentage)))"
                                               [ngClass]="{'is-invalid': (!item.wbsPercentage || wbsErrorForSurcharge) && f.submitted}" />
                                      </div>
                                      <div class="col-1 percentageSign">%</div>
                                    </div>
                                  </div>

                                  <div class="col-2">
                                    <div [hidden]="i == 0" class="removeWBS"
                                         (click)="!(!isInputWbsSurchargeChanged && (!session.surcharge || session.surcharge < 0 || isSessionCreatedFromCommercialization || (userRoleID!=1 && userRoleID!=3 && item.wbsCode )||(eventName!='' && eventName!=null && !enableSurchargeWBS) || (userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23  ))))  && updateWBSFieldsForSurcharge('delete',item.id)"
                                         [ngClass]="{'disabled': !session.surcharge || session.surcharge < 0 }">
                                      Remove
                                    </div>
                                  </div>
                                </div>
                                <div class="pad0"
                                     [ngClass]="multipleWBSForSurcharge.length > 1 ? 'col-4' : 'col-12'">
                                  <span id="wbs_info_text_surcharge" [class.wbs-info-shifted]="searchingWBSSurcharge">
                                    Enter a chargeable 22- character code (e.g., ZYW12345-01-01-01-0000). New code(s) may take few hours to appear; save as draft and retry later.
                                  </span>
                                </div>
                                <div>
                                  <button type="button"
                                          [ngClass]="{'disabled': (totalWBSPercentageForSurcharge >= 100 || disableAddWBSForSurcharge || invalidWBSForSurcharge || !session.surcharge || session.surcharge < 0 || isSessionCreatedFromCommercialization || (!isInputWbsSurchargeChanged && (!session.surcharge || session.surcharge < 0 || isSessionCreatedFromCommercialization || (userRoleID!=1 && userRoleID!=3)||(eventName!='' && eventName!=null && !enableSurchargeWBS) || (userRoleID == 3 && session.approvalStatus == 'Approved' && ( sessionId != 0 && session.subscriptionId && session.sponsoredCountry == 23  )))) )}"
                                          class="addWBSClass"
                                          (click)="$event.preventDefault();updateWBSFieldsForSurcharge('add')">
                                    Add
                                    Surcharge WBS
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="row pt15">
                              <div class="col-12">
                                <div class="mandatoryFieldsError"
                                     *ngIf="!isSelected('Deloitte') && (wbsError || wbsErrorForSurcharge || invalidPercenatge || invalidPercenatgeForSurcharge)">
                                  Please confirm that percentages to charge each WBS code equal 100% total or remove the
                                  additional codes.
                                </div>
                                <div class="mandatoryFieldsError"
                                     *ngIf="!isSelected('Deloitte') && (invalidWBS || invalidWBSForSurcharge) && multipleWBS[0].wbsCode && !invalidWBSDunsID">
                                  Please enter valid WBS code
                                </div>
                                <div class="mandatoryFieldsError"
                                     *ngIf="!isSelected('Deloitte') && invalidWBSDunsID && multipleWBS[0].wbsCode">
                                  Invalid WBS code - The selected WBS does not match the company's DunsID.
                                </div>
                                <div class="mandatoryFieldsError"
                                     *ngIf="!isSelected('Deloitte') && !isWBSAccordionHidden() && !multipleWBS[0].wbsCode && isWBSMandatory && f.submitted">
                                  Please provide the missing WBS code(s) to submit your request or save as draft and reach out to Chief Chemist.
                                </div>
                              </div>
                            </div>
                          </div>
            </div>
          </div>

          <!-- 5 Accordian Roles-->
          <div class="panel panel-default" id="tab5">
            <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse_6')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab5')">
                <a data-bs-parent="#accordion">Roles</a>
              </h4>
            </div>
            <div id="collapse_6" class="panel-collapse collapse accordion5">
              <div class="panel-body accordianSection">
                <div class="row">

                  <div class="col-4">
                    <label for="sessionRequester">Session Requester <span class="mandatoryMark">*</span></label>
                    <input type="text" id="sessionRequester" class="form-control"
                           name="sessionRequester" [(ngModel)]="session.sessionRequester"
                           #sessionRequester="ngModel"
                           [ngClass]="{ 'is-invalid': f.submitted && sessionRequester.invalid && session.sessionRequester === ''}"
                           [disabled]="(sessionId !== 0 && ((session.approvalStatus == 'Approved' && !session.subscriptionId )|| (userRoleID == 4 && session.approvalStatus != 'Draft'))
                                               && (userRoleID != 1 && userRoleID != 3 && userRoleID != 5 && userRoleID != 6))"
                           required />
                  </div>

                                    <div class="col-4 responsiblePpmdMar10" >
                                        <label [for]="showPPMDAsTextInput ? 'ppmdID_text' : (draftSession ? 'ppmdID_draft' : 'ppmdID_submitted')">
                                            Responsible PPMD or Leader <span class="mandatoryMark"
                                                *ngIf="!showPPMDAsTextInput">*</span>
                                        </label>
                                        <input *ngIf="!showPPMDAsTextInput && draftSession" id="ppmdID_draft" type="text"
                                            class="form-control responsiblePpmd" [(ngModel)]="session.responsiblePpmd"
                                            #responsiblePpmd="ngModel" [ngbTypeahead]="searchPPMD"
                                            [resultFormatter]="formatPPMD" [inputFormatter]="formatPPMDSelection"
                                            name="responsiblePpmd"
                                            [ngClass]="{ 'is-invalid': !draftSession && f.submitted && (responsiblePpmd.invalid || textLimitErrorPPMD || invalidppmd), 'reduce-bottom-margin' : textLimitErrorPPMD }"
                                            [disabled]="(sessionId !== 0 && (session.approvalStatus == 'Approved' || (userRoleID == 4 && session.approvalStatus != 'Draft')) && (userRoleID != 1 && userRoleID != 3 && userRoleID != 2 && userRoleID != 8 && userRoleID != 5 && userRoleID != 6)) || disableSubscriptionFields " />
                                        <input *ngIf="!showPPMDAsTextInput && !draftSession" id="ppmdID_submitted" type="text"
                                            class="form-control responsiblePpmd" [(ngModel)]="session.responsiblePpmd"
                                            #responsiblePpmd="ngModel" [ngbTypeahead]="searchPPMD"
                                            [resultFormatter]="formatPPMD" [inputFormatter]="formatPPMDSelection"
                                            name="responsiblePpmd"
                                            [ngClass]="{ 'is-invalid': !draftSession  && f.submitted && (responsiblePpmd.invalid || textLimitErrorPPMD || invalidppmd), 'reduce-bottom-margin' : textLimitErrorPPMD }"
                                            [disabled]="(sessionId !== 0 && (session.approvalStatus == 'Approved' || (userRoleID == 4 && session.approvalStatus != 'Draft')) && (userRoleID != 1 && userRoleID != 3 && userRoleID != 2 && userRoleID != 8 && userRoleID != 5 && userRoleID != 6)) || disableSubscriptionFields"
                                            required />

                                        <input *ngIf="showPPMDAsTextInput" id="ppmdID_text" type="text" class="form-control responsiblePpmd"
                                            [(ngModel)]="session.responsiblePpmd"
                                            (ngModelChange)="onFocusOutType(session.responsiblePpmd, 'PPMD')"
                                            #responsiblePpmd="ngModel" name="responsiblePpmd"
                                            [ngClass]="{'reduce-bottom-margin' : textLimitErrorPPMD}"
                                            [disabled]="(sessionId !== 0 && (session.approvalStatus == 'Approved' || (userRoleID == 4 && session.approvalStatus != 'Draft')) && (userRoleID != 1 && userRoleID != 3 && userRoleID != 2 && userRoleID != 8 && userRoleID != 5 && userRoleID != 6)) || disableSubscriptionFields" />
                                        <div class="minCharErrorMsg"
                                            *ngIf="textLimitErrorPPMD && session.responsiblePpmd">
                                            Please enter 3 or
                                            more characters
                                        </div>
                                    </div>
                                </div>
                                <div class="row session-margin">
                                    <div class="col-12">
                                        <label for="typeahead-format">
                                            Session Coordinator <span class="mandatoryMark">*</span>
                                        </label>
                                    </div>
                                    <div class="col-4">

                    <input id="typeahead-format" type="text" class="form-control"
                           (selectItem)="updateCoordinator($event, 'add', true)"
                           [(ngModel)]="session.sessionCoordinators" #sessionCoordinators="ngModel"
                           [ngbTypeahead]="searchCoordinator" [resultFormatter]="formatCoordinator"
                           [inputFormatter]="formatCoordinator" name="sessionCoordinators"
                           [ngClass]="{ 'is-invalid': f.submitted && selectedCoordinators.length == 0 , 'reduce-bottom-margin' : textLimitErrorCoordinator}" />
                    <div *ngIf="textLimitErrorCoordinator" class="minCharErrorMsg">
                      Please enter 3 or
                      more characters
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="selected-list">
                      <span *ngFor="let item of selectedCoordinators">
                        <span class="user-name"
                              *ngIf="item.EmailAddress.includes('@_masked.com')">
                          {{item.FirstName}} {{item.LastName}}
                        </span>
                        <span class="user-name"
                              *ngIf="!item.EmailAddress.includes('@_masked.com')">
                          {{item.FirstName}} {{item.LastName}} (
                          {{item.EmailAddress}} )
                        </span>
                        <span class="delete" (click)="updateCoordinator(item, 'delete', false)"
                              aria-hidden="true">×</span>&nbsp;&nbsp;
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label for="typeahead-certified-facilitator">
                      Certified Facilitator (confirm availability before
                      entering) <span class="mandatoryMark">*</span>
                    </label>
                  </div>

                  <div class="col-4 positionRelative">
                    <input id="typeahead-certified-facilitator" type="text" class="form-control"
                           (selectItem)="updateCertifiedFacilitator($event, 'add')"
                           [(ngModel)]="session.certifiedFacilitator" #certifiedFacilitator="ngModel"
                           [ngbTypeahead]="searchFacilitators" [resultFormatter]="formatFacillitator"
                           [inputFormatter]="formatFacillitator" name="certifiedFacilitator"
                           [ngClass]="{'is-invalid':f.submitted && (selectedFacilitator.length == 0 ||  ((selectedFacilitator.length == 0 || isClientCertifiedFacilitator == false) &&
                                             (session.sessionType == 'ExternalClient' || session.sessionType == 'MixedAudience') &&
                                             (userRoleID == 2 || userRoleID == 8 || userRoleID == 4 ) && (session.sessionTypes == 8 || session.sessionTypes == 24 ))) && draftSession == false }"
                           [disabled]="sessionId !== 0 && (session.approvalStatus == 'Approved' || (userRoleID == 4 && session.approvalStatus != 'Draft')) && (userRoleID != 1 && userRoleID != 3 )" />
                    <span class="CertifiedFacilitatorIcon"
                          title="Click here to search for a facilitator"
                          (click)="openFacillitator()"></span>
                  </div>
                  <div class="col-8">
                    <div class="selected-list"
                         [ngClass]="{'disabled': sessionId !== 0 && (userRoleID == 4 || (session.approvalStatus == 'Approved' && (userRoleID == 2 || userRoleID == 8 || userRoleID == 5 || userRoleID == 6)))}">
                      <span *ngFor="let item of selectedFacilitator">
                        <span [ngClass]="item.CertificationlevelID == 1 ? 'certified-facilitator' : 'user-name'"
                              *ngIf="item.Email.includes('@_masked.com')">
                          {{item.FirstName}} {{item.LastName}}
                        </span>
                        <span [ngClass]="item.CertificationlevelID == 1 ? 'certified-facilitator' : 'user-name'"
                              *ngIf="!item.Email.includes('@_masked.com')">
                          {{item.FirstName}} {{item.LastName}} (
                          {{item.Email}} )
                        </span>
                        <span class="delete"
                              (click)="updateCertifiedFacilitator(item, 'delete')"
                              aria-hidden="true">×</span>&nbsp;&nbsp;
                      </span>
                    </div>
                  </div>
                  <!-- Message 1: Select a BC 2.0 certified facilitator -->
                  <div class="col-12 mtMinus15"
                       *ngIf="((session.sessionTypes == 1 || session.sessionTypes == 16 || session.sessionTypes == 4 || session.sessionTypes == 18 || session.sessionTypesEvent == 18) && session.contentArea == 2) && (selectedFacilitator.length == 0 || isClientCertifiedFacilitator == false)">
                    <small class="facilitator-text">Select a facilitator certified in the BC 2.0 topic of your session</small>
                  </div>
                  <!-- Message 2: Select a Client-Certified BC 2.0 facilitator -->
                  <div class="col-12 mtMinus15"
                       *ngIf="((session.sessionTypes == 8 || session.sessionTypes == 24 || session.sessionTypes == 10 || session.sessionTypes == 27 || session.sessionTypesEvent == 17 || session.sessionTypesEvent == 19) && session.contentArea == 2) && (selectedFacilitator.length == 0 || isClientCertifiedFacilitator == false)">
                    <small class="facilitator-text">Select a Client-Certified facilitator certified in the BC 2.0 topic of your session</small>
                  </div>
                  <!-- Message 3: Select a Client-Certified facilitator -->
                  <div class="col-12 mtMinus15"
                       *ngIf="((session.sessionTypes == 8 || session.sessionTypes == 24 || session.sessionTypes == 10 || session.sessionTypes == 27 || session.sessionTypesEvent == 17 || session.sessionTypesEvent == 19) && session.contentArea == 1) && (selectedFacilitator.length == 0 || isClientCertifiedFacilitator == false)">
                    <small class="facilitator-text">Select a Client-Certified facilitator</small>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <!--9 Accordion Session Feedback-->
          <div class="panel panel-default" id="tab9" *ngIf="(session.sponsoredCountry == '23' || session.sponsoredCountry == '266') && !InvalidAge && !session.subscriptionId &&((session.sessionType == 'ExternalClient' && (session.sessionTypes == '8' ||
                    session.sessionTypes == '10' || (session.sessionTypes =='13' && session.sessionSubTypes == '1' ) || session.sessionTypes == '15')) || (session.sessionType == 'ExternalNonClient' && (session.sessionTypes == '16' ||
                    session.sessionTypes == '18' || (session.sessionTypes =='20' && session.sessionSubTypes == '5') || session.sessionTypes == '31' ||  session.sessionTypes == '23')) || (session.sessionType == 'MixedAudience' && (session.sessionTypes == '24' || session.sessionTypes == '27' ||
                    session.sessionTypes == '28' || session.sessionTypes =='32' || session.sessionTypes == '30')))">
            <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse9')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab9')">
                <a data-bs-parent="#accordion" data-bs-target="#collapse9">
                  Session Feedback 
                </a>
              </h4>
            </div>
            <div id="collapse9" class="panel-collapse collapse accordion9">
              <div class="panel-body accordianSection">

                <div class="col-12">
                  <div class="row">
                    <div id="subText" class="col-6">
                      <label for="optOut">The system will generate a Feedback ID that the facilitator can use to request feedback at the end of the session. Click here to <a href="https://amedeloitte.sharepoint.com/:w:/r/sites/DOL-c-US-BizChemHub/Nonfacilitator%20Drive/Admin%20Portal%20Toolkit/bc-session-feedback-guide-for-facilitators.docx?d=w03cb73ecc0784702a86ddf729fc6251d&csf=1&web=1&e=uE1S09" target="_blank">learn more</a></label>
                    </div>
                    <div class="col-5">
                      <div class="form-group">
                        <select class="form-control custom-select" id="optOut" [(ngModel)]="optOut"  
                                  name="optOut"  [disabled]="sessionId !=0 && userRoleID != 1 && session.approvalStatus =='Approved' ? true:false"
                                  >

                            <option value=null hidden disabled selected>Please Select</option>
                            <option *ngFor="let option of sessionFeedbackOptions"
                                    [value]= option.ID>
                              {{option.name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                    <div class="row feedbackdiv">
                    <div class="col-12 p-relative" *ngIf="approvalStatus == 'Approved'&& FeedbackId != '' && optOut=='IAgree' ">
                      <div class="feedback-row">
                        <div class="feedback-col-1">
                          <label for="feedbackId">
                            Feedback ID
                          </label>
                        </div>
                        <div class="feedback-col-2">
                          <span *ngIf="isFeedbackIdCopied" class="copy-feedback">FeedbackId has been copied</span>
                          <input type="text" id="feedbackId" value={{FeedbackId}} disabled>

                          <span class="feedbackCopyIcon"
                                [ngClass]="{'feedbackHandIcon':FeedbackId, 'copied-style':isFeedbackIdCopied}"
                                (click)="copyFeedbackId()"
                                [title]="FeedbackId ? 'Copy FeedbackId' : '' "></span>
                        </div>
                      </div>
                      
                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-9 row optOutTextDiv" *ngIf="optOut=='optOut'"  >
                  <div>
                    <label for="textOptOutReason">
                      Reason for Opt Out<span class="mandatoryMark">*</span>
                    </label>
                    <textarea  class="sessionComments form-control" [(ngModel)]="OptOutReason" name="OptOutReason" id="textOptOutReason" (ngModelChange)="validateOptOutReason()" [ngClass]="{'is-invalidOptOutReason':f.submitted && optOut  && (invalidOptOutReason || OptOutReason == '') }" [disabled]="sessionId !=0 && userRoleID != 1 && session.approvalStatus =='Approved' ? true:false"></textarea>
                    <span style="color:red" *ngIf="f.submitted && (OptOutReason == '' || invalidOptOutReason )">{{invalidOptOutReasonText}}</span>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 6 Accordian Session Summary-->
          <div class="panel panel-default" id="tab6">
            <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse_06')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab6')">
                <a data-bs-parent="#accordion">
                  Session
                  Summary
                </a>
              </h4>
            </div>
            <div id="collapse_06" class="panel-collapse collapse accordion6">
              <div class="panel-body accordianSection">
                <div class="row">
                  <div class="col-4">
                    <label for="displayName">Display Name or Opportunity ID</label>
                    <input id="displayName" type="text" class="form-control marB5" [(ngModel)]="session.displayName"
                           #sessionName="ngModel" name="displayName" />
                    <div class="subText-checkbox">
                      It may be helpful to create a display name in
                      addition to the non-editable session name.
                    </div>
                  </div>
                  <div class="col-2">

                  </div>
                  <div class="col-4"
                       *ngIf="(sessionId != 0 && session.subscriptionId && (session.approvalStatus == 'Approved' || session.approvalStatus =='Approval Pending' || session.approvalStatus == 'Cancelled' || session.approvalStatus == 'Not Approved' ) && (userRoleID == 6 || userRoleID==3 || userRoleID==1))">
                    <button type="button" class="usageReport"
                            (click)="DownloadSubsUsageReport(session.subscriptionId)">
                      Subscription Usage Report
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="sessionComments" *ngIf="!isSelected('Deloitte')">Comments</label>
                    <textarea id="sessionComments" class="sessionComments form-control" name="sessionComments"
                              [(ngModel)]="session.sessionComments" #sessionComments="ngModel"
                              placeholder="{{commentsPlaceholder}}"></textarea>
                  </div>
                </div>
                <div class="row" *ngIf="!isSelected('Deloitte') && !InvalidAge && (session.approvalStatus == 'To Review' || session.approvalStatus == 'Approval Pending' ||
                                     session.approvalStatus == 'New' || session.approvalStatus == 'Approved')">
                  <div class="col-6">
                    <div class="row">
                      <div class="col pr0">
                        <label for="report">
                          Check here if you would like to receive additional usage
                          reports
                        </label>
                        <span class="c-suite-checkbox">
                          <input type="checkbox" id="report" name="reportCheck"
                                 #reportCheck="ngModel" [(ngModel)]="session.reportCheck"
                                 [checked]="isReportGeneration"
                                 (change)="onReportSelect($event)" />
                        </span>
                      </div>
                    </div>
                    <div id="usageReportSubText" class=" row col-9 subText-checkbox">
                      You will receive an
                      automatically generated usage report five days before the session. If you
                      wish to receive more, check here.
                    </div>
                  </div>
                  <div class="col-3" id="howOftenDropdown">
                    <div class="form-group">
                      <label for="sessionReportSel">
                        How Often <span *ngIf="isReportGeneration"
                                        class="mandatoryMark">*</span>
                      </label>
                      <select id="sessionReportSel" class="form-control custom-select" #sessionReport="ngModel"
                              name="sessionReport" [(ngModel)]="session.sessionReport"
                              (ngModelChange)="sessionReportChange($event)"
                              [ngClass]="{ 'is-invalid': f.submitted && sessionReport.invalid }"
                              [required]="isReportGeneration" [disabled]="!isReportGeneration">
                        <option value=null hidden disabled selected>Please Select</option>
                        <option value=1>Daily</option>
                        <option value=2>Weekly</option>
                        <option value=3>Monthly</option>
                        <option value=4>Day before session date</option>
                      </select>
                      <i class="fa fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
                <div class="col-2 statusClass"
                     *ngIf="showApproveOptions && session.approvalStatus != 'Draft'">
                  <div>
                          <input type="radio" name="approvedStatus" [(ngModel)]="session.approvalStatus"
                            (click)="onApprove('Approved')" value="Approved" id="approved"
                            [disabled]="disableApprove || disableApproveDueToWbs" /> <label for="approved">Approved</label>
                  </div>
                  <div *ngIf="showSessionNotApproved">
                    <input type="radio" name="notApprovedStatus"
                           [(ngModel)]="session.approvalStatus" (click)="onApprove('Not Approved')"
                           value="Not Approved" id="notApproved" [disabled]="disableApprove" /> <label for="notApproved">
                      Not
                      Approved
                    </label>
                  </div>
                  <div>
                    <input type="radio" name="cancelledStatus" [(ngModel)]="session.approvalStatus"
                           (click)="onApprove('Cancelled')" value="Cancelled" id="cancelled"
                           [disabled]="disableApprove" /> <label for="cancelled">Cancelled</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 7 Accordian Participant Details-->
          <div class="panel panel-default"
               *ngIf="((session.sessionLink && !isSelected('Deloitte')) || (session.approvalStatus == 'Approval Pending' && (userRoleID == 1 || userRoleID == 3)) || ((session.approvalStatus == 'Approved' || session.approvalStatus == 'Cancelled' || session.approvalStatus == 'Not Approved')  && !isSelected('Deloitte')) )"
               [ngClass]="{'disabled': disableParticipantsTab}" id="tab7">
            <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse7')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab7')">
                <a data-bs-parent="#accordion" data-bs-target="#collapse7">
                  Participant Details
                </a>
              </h4>
            </div>
            <div id="collapse7" class="panel-collapse collapse accordion7">
              <div class="panel-body">
                <div class="col-12 participantsDetails" *ngIf="!isSelected('Deloitte')">
                  <div class="row">
                    <div class="col-8">
                      <label for="managerLink">Session Participant Manager for Clients</label>
                      <input type="text" name="ManagerLink" [(ngModel)]="managerLink" id="managerLink"
                             disabled />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <input type="checkbox" id="requiredDomainEmails"
                             [checked]="requiredDomainEmailsVal"
                             (change)="onCheckboxChange($event)" /> <label for="requiredDomainEmails">Domains/Emails Required</label>
                      <div class="subText-checkbox">Business Chemistry Team Use Only</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="nav nav-tabs" id="myTab" role="tablist">
                        <div class="nav-item">
                          <button class="nav-link"
                                  [ngClass]="{'active': selectedTab === 'domain'}" id="domain-tab"
                                  data-toggle="tab" data-bs-target="#domain" type="button"
                                  role="tab" aria-controls="domain"
                                  (click)="onTabClick('domain')">
                            Domains
                          </button>
                        </div>
                        <div class="nav-item">
                          <button class="nav-link"
                                  [ngClass]="{active: selectedTab === 'participant'}"
                                  id="participant-tab" data-toggle="tab"
                                  data-bs-target="#participant" type="button" role="tab"
                                  aria-controls="participant" (click)="onTabClick('participant')">
                            Emails
                          </button>
                        </div>
                        <div class="nav-item"
                            *ngIf="showClientAdminAndManagerLink">
                          <button class="nav-link"
                                  [ngClass]="{active: selectedTab === 'clientadmins'}"
                                  id="clientadmins-tab" data-toggle="tab"
                                  data-bs-target="#clientadmins" type="button" role="tab"
                                  aria-controls="clientadmins"
                                  (click)="onTabClick('clientadmins')">
                            Client Admins
                          </button>
                        </div>
                      </div>
                      <div class="error-message" *ngIf="invalidDomainInfo">
                        <p><i class="fa fa-warning"></i> Please enter domain(s)</p>
                      </div>
                      <div class="error-message" *ngIf="invalidEmailInfo">
                        <p><i class="fa fa-warning"></i> Please enter email(s)</p>
                      </div>
                      <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade"
                             [ngClass]="{'show active': selectedTab === 'domain'}" id="domain"
                             role="tabpanel" aria-labelledby="domain-tab">
                          <div id="domains" class="">
                            <div id="ValidationMessage"
                                 *ngIf="enableEmailInfo && domainErrors && domainErrors.length > 0">
                              <div *ngFor="let error of domainErrors"
                                   class="error-message">
                                <p><i class="fa fa-warning"></i>{{error}}</p>
                              </div>
                            </div>
                            <h6 class="subTitles">Domain Information </h6>
                            <h6 class="subTitles subText1">
                              <strong>
                                Please list the domain(s)
                                only (Ex: "domain.com", not "&#64;domain.com")
                              </strong>
                            </h6>
                            <h6 class="subText1">
                              Add multiple domains by copying and pasting
                              from an .xls or .doc file. Use commas or line breaks
                              (Return) after each domain name to enter them separately
                              (max. of 50).
                            </h6>
                            <textarea class="sessionComments form-control" name="domainInfo"
                                      [(ngModel)]="session.domainInfo" #domainInfo="ngModel"
                                      [disabled]="!enableEmailInfo"
                                      [ngClass]="{ 'is-invalid': f.submitted && domainInfo.invalid }"></textarea>
                            <div class="text-right">
                              <button type="button" class="clickBtn"
                                      (click)="updateDomain(session.domainInfo, 'add')"
                                      [ngClass]="{'disabled': !enableEmailInfo}">
                                ADD
                              </button>
                            </div>
                            <div *ngIf="domainNameList && domainNameList.length > 0">
                              <h3 class="subTitles">Domain Preview</h3>
                              <p>
                                {{domainNameList.length}} / 50 domains have been added.
                              </p>
                              <div class="emailGrid"
                                   [ngClass]="{'disabled': !enableEmailInfo}">
                                <div class="gridHeader">Domain</div>
                                <div class="row" *ngFor="let domain of domainNameList">
                                  <div class="col-6">{{domain}}</div>
                                  <div class="col-6">
                                    <span *ngIf="enableEmailInfo" class="trashIcon"
                                          (click)="updateDomain(domain, 'delete')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="tab-pane fade"
                             [ngClass]="{'show active': selectedTab === 'participant'}"
                             id="participant" role="tabpanel" aria-labelledby="participant-tab">
                          <div id="participantEmails" class="">
                            <div id="participantValidationMessage"
                                 *ngIf="enableEmailInfo && emailsErrors && emailsErrors.length > 0">
                              <div *ngFor="let error of emailsErrors"
                                   class="error-message">
                                <p><i class="fa fa-warning"></i>{{error}}</p>
                              </div>
                            </div>
                            <h6 class="subTitles">Participant Email Information</h6>
                            <h6 class="subText1">
                              Add multiple email addresses by copying and
                              pasting from an .xls or .doc file. Use commas or line breaks
                              (Return) after each email address to enter them separately
                              (max. of 5000).
                            </h6>
                            <textarea class="sessionComments form-control"
                                      name="participantEmailInfo"
                                      [(ngModel)]="session.participantEmailInfo"
                                      #participantEmailInfo="ngModel"
                                      [disabled]="!enableEmailInfo"
                                      [ngClass]="{ 'is-invalid': f.submitted && participantEmailInfo.invalid }"></textarea>
                            <div class="text-right">
                              <button type="button" class="clickBtn"
                                      (click)="updateParticipantEmail(session.participantEmailInfo, 'add')"
                                      [ngClass]="{'disabled': !enableEmailInfo}">
                                ADD
                              </button>
                            </div>
                            <div *ngIf="participantEmailList && participantEmailList.length > 0">
                              <h3 class="subTitles">Participant Preview</h3>
                              <p>
                                {{participantEmailList.length}}/5000 emails have been
                                added.
                              </p>
                              <div class="emailGrid"
                                   [ngClass]="{'disabled': !enableEmailInfo}">
                                <div class="gridHeader">Email</div>
                                <div class="row"
                                     *ngFor="let email of participantEmailList">
                                  <div class="col-6">{{email}}</div>
                                  <div class="col-6">
                                    <span *ngIf="enableEmailInfo" class="trashIcon"
                                          (click)="updateParticipantEmail(email, 'delete')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="showClientAdminAndManagerLink" class="tab-pane fade"
                             [ngClass]="{'show active': selectedTab === 'clientadmins'}"
                             id="clientadmins" role="tabpanel"
                             aria-labelledby="clientadmins-tab">
                          <div id="clientAdminEmails" class="">

                            <div id="clientAdminValidationMessage"
                                 *ngIf="enableEmailInfo && clientEmailErrors && clientEmailErrors.length > 0">
                              <div *ngFor="let error of clientEmailErrors"
                                   class="error-message">
                                <p><i class="fa fa-warning"></i>{{error}}</p>
                              </div>
                            </div>
                            <h6 class="subTitles">
                              Client Admin Email Information
                            </h6>
                            <h6 class="subText1">
                              Add multiple client admins by copying and pasting from an
                              .xls or .doc file. Use commas or line breaks (Return) after
                              each client admin email to enter them separately (max. of
                              25).
                            </h6>
                            <textarea class="sessionComments form-control"
                                      name="clientEmailInfo" [(ngModel)]="session.clientEmailInfo"
                                      #clientEmailInfo="ngModel" [disabled]="!enableEmailInfo"
                                      [ngClass]="{ 'is-invalid': f.submitted}"></textarea>
                            <div class="text-right">
                              <button type="button" class="clickBtn"
                                      (click)="updateClientAdmin(session.clientEmailInfo, 'add')"
                                      [ngClass]="{'disabled': !enableEmailInfo}">
                                ADD
                              </button>
                            </div>
                            <div *ngIf="externalAdminEmailList && externalAdminEmailList.length > 0">
                              <h3 class="subTitles">Participant Preview</h3>
                              <p>
                                {{externalAdminEmailList.length}}/25 emails have been
                                added.
                              </p>
                              <div class="emailGrid"
                                   [ngClass]="{'disabled': !enableEmailInfo}">
                                <div class="gridHeader">Email</div>
                                <div class="row"
                                     *ngFor="let email of externalAdminEmailList">
                                  <div class="col-6">{{email}}</div>
                                  <div class="col-6">
                                    <span *ngIf="enableEmailInfo" class="trashIcon"
                                          (click)="updateClientAdmin(email, 'delete')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- code for audit trail -->
          <!-- 8 Accordian Audit Trail-->
          <div class="panel panel-default"
               *ngIf="sessionId != 0 && (userRoleID == 1 || userRoleID == 3) && session.approvalStatus != 'Draft'"
               id="tab8">
            <div class="panel-heading" (click)="userRoleService.closeAccordion('#collapse8')">
              <h4 class="panel-title" (click)="ScrollIntoView('#tab8')">
                <a data-bs-parent="#accordion" data-bs-target="#collapse8">
                  Audit Trail <span *ngIf="isSessionCreatedFromWRF">
                    &nbsp;&nbsp; (Entered via Web
                    Form)
                  </span>
                </a>
              </h4>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
              <div class="panel-body accordianSection">
                <!-- Audit Trails/History/Activity -->
                <app-audit-trail [auditTrailList]="auditTrailList" [sessionID]="sessionId">
                </app-audit-trail>


              </div>
            </div>
          </div>
        </div>
        <!--Modal for Draft at the time of creation a new session-->
        <div class="updateEmail">
          <div class="modal" #updateEmail id="draft_session" tabindex="-1" role="dialog"
               aria-labelledby="exampleModalLabel">
            <div class="updateEmail-dialog">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title" id="exampleModalLabel">Session Saved as Draft</h4>
                  </div>
                  <div class="modal-body">
                    <div *ngIf="idforpopup == 0">
                      <div>
                        <!-- change the msg based on CR: 2705700 -->
                        <p>
                          Your session <strong class="sessionNameWhiteSpace">{{sessionNameInPopUp}}</strong> has been saved as a draft! You can access your draft request from the Session Search screen.
                        </p>
                        <p>
                          Please note that this form will be available for submission for the next 90 days, after which it will be auto-deleted from the system.
                        </p>
                      </div>
                    </div>
                    <div *ngIf="idforpopup != 0 && approvalStatus == 'Draft'">
                      <p>
                        Your draft has been successfully updated and saved.
                      </p>
                    </div>

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default editEmailSaveBtn"
                            data-bs-dismiss="modal" (click)="afterPopupClose('Draft')">
                      DONE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--End Modal for Draft-->
        <!--<ng-template #content let-modal>-->

        <div class="updateEmail">
          <div class="modal" #updateEmail id="save_session" tabindex="-1" role="dialog"
               aria-labelledby="saveSessionModalLabel">
            <div class="updateEmail-dialog">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title" id="saveSessionModalLabel">Session Submitted</h4>
                  </div>
                  <div class="modal-body">
                    <div *ngIf="idforpopup == 0">
                      <p *ngIf="isSelected('Deloitte')">
                        Your session has been successfully created
                      </p>
                      <div *ngIf="isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience')">
                        <p>Your session has been saved! Please read for next steps.</p>
                        <p>
                          Thank you for creating <strong class="sessionNameWhiteSpace">{{sessionNameInPopUp}}</strong>
                          session.
                        </p>

                        <p>
                          Inside the U.S., your request has been submitted to the <strong>
                            Chief Chemist
                          </strong> for approval, it will be reviewed and
                          approved within two business days.
                        </p>

                        <p>
                          Outside the U.S., your request has been submitted to the
                          <strong>Country Admin</strong> for approval.
                        </p>
                      </div>
                    </div>
                    <div *ngIf="idforpopup != 0 && approvalStatus != 'Draft'">
                      <p>Your session has been successfully updated.</p>
                    </div>

                    <!-- when draft edit session saved(click on submit button) -->
                    <div *ngIf="idforpopup != 0 && approvalStatus == 'Draft'">
                      <div>
                        <p>Your session has been saved! Please read for next steps.</p>
                        <p>
                          Thank you for creating <strong class="sessionNameWhiteSpace">{{sessionNameInPopUp}}</strong>
                          session.
                        </p>

                        <p>
                          Inside the U.S., your request has been submitted to the <strong>
                            Chief Chemist
                          </strong> for approval, it will be reviewed and
                          approved within two business days.
                        </p>

                        <p>
                          Outside the U.S., your request has been submitted to the
                          <strong>Country Admin</strong> for approval.
                        </p>
                      </div>
                    </div>

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default editEmailSaveBtn"
                            data-bs-dismiss="modal" (click)="afterPopupClose('Submit')">
                      DONE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!-- modal popup for valid WBS code -->
        <div class="updateEmail">
          <div class="modal" #updateEmail id="valid_wbs" tabindex="-1" role="dialog"
               data-bs-backdrop="static" data-bs-keyboard="false"
               aria-labelledby="validWbsModalLabel">
            <div class="updateEmail-dialog">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title" id="validWbsModalLabel">Please Confirm</h4>
                  </div>
                  <div class="modal-body">
                   
                    <p>
                      This event has an associated fee. The charges will be billed to the code(s) you entered by the next finance accounting period.
                    </p>
                    <ul>
                      <li>Click YES to confirm that the billable code(s) you provided will remain active for the next six weeks.</li>
                      <li>Click NO if you need to enter a different billable code.</li>
                    </ul>
                    <div class="form-check mt-3">
                      <input class="form-check-input" type="checkbox" id="confirmWbsCode"
                             [(ngModel)]="IsWBSCodeConfirmed" (change)="onWbsConfirmationChange($event)" name="confirmWbsCode" />
                      <label class="form-check-label" for="confirmWbsCode">
                        I acknowledge the entered code is accurate and can be used.
                      </label>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal"
                            [disabled]="!IsWBSCodeConfirmed">
                      YES
                    </button>
                    <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal"
                            (click)="ClearWBS('current')">
                      NO
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!-- end of valid WBS code modal popup -->
        <div class="row"
             *ngIf="sessionId != 0 && userRoleID != 1 && userRoleID != 3 && approvalStatus != 'Draft'">
          <div class="col-12">
            <span class="text-bottom">Created by {{createdBy}} {{FormatedCreatedDate}}</span>
            <br>
            <span class="text-bottom">Last Modified by {{lastModifiedBy}} {{FormatedModifiedDate}} </span>
          </div>
        </div>

        <!-- in case of editing draft session , show only created by (2650982) -->
        <div class="row" *ngIf="sessionId != 0 && approvalStatus == 'Draft'">
          <div class="col-12">
            <span class="text-bottom">Created by {{createdBy}} {{FormatedCreatedDate}}</span>
          </div>
        </div>

        <div id="errorMsg" class="pt10">
          <div class="mandatoryFieldsError" *ngIf="f.submitted && (!f.form.valid || !validForm)">
            Please fill
            all the mandatory fields (*)
          </div>
          <div class="mandatoryFieldsError"
               *ngIf="!isSelected('Deloitte') && inactiveWbsError && showApproveOptions">
            Code(s) is no longer active.
          </div>
          <div class="mandatoryFieldsError" *ngIf="invalidSessionRequester">
            Invalid email(s) found, please
            provide an alternate email to continue.
          </div>
        </div>
        <div class="row"
             *ngIf="isSelected('Deloitte') || isSelected('ExternalClient') || isSelected('ExternalNonClient') || isSelected('MixedAudience') || (session.showsession) ">
          <div class="col-4"></div>
          <div class="col-8 text-right">
            <button type="button" class="clickBtn mr10" (click)="$event.preventDefault(); onExit();">
              Close
            </button>
            <!-- Bug 3652635 fix -->
            <button id="draftButton" type="submit" class="clickBtn mr10"
                    [disabled]="IsAfterSubmit || (!f.form.dirty && !isaudienceChanged)"
                    [ngClass]="{'disabled': !f.form.dirty && !isaudienceChanged }"
                    (click)="this.validateWBSCodeOnSubmit(); this.validateWBSCodeOnSubmitForSurcharge(); this.checkWBSError(); this.checkWBSErrorForSurcharge(); this.validateWBSPercentage(); this.validateWBSPercentageForSurcharge(); this.validateSessionRequesterEmail(); this.checkInvalidCompany(); this.openAccordian(f.form.valid, f.form.getRawValue(),'draft');"
                    [hidden]="session.approvalStatus != 'Draft' && session.approvalStatus != 'New'  ">
              Save Draft
            </button>
            <!-- Bug 3652635 fix -->
            <button id="subButton"
                    [disabled]="IsAfterSubmit || (!f.form.dirty && !isaudienceChanged && !issubmitEnable)"
                    type="submit"
                    [ngClass]="{'disabled': (!f.form.dirty && !isaudienceChanged && !issubmitEnable)}"
                    class="clickBtn"
                    (click)="this.onFocusoutSessionDate(); this.validateWBSCodeOnSubmit(); this.validateWBSCodeOnSubmitForSurcharge(); this.checkWBSError(); this.checkWBSErrorForSurcharge(); this.validateWBSPercentage(); this.validateWBSPercentageForSurcharge(); this.validateSessionRequesterEmail(); this.checkInvalidCompany(); this.openAccordian(f.form.valid, f.form.getRawValue(),'submit');">
              Submit
            </button>
          </div>
        </div>

      </form>
    </div>

  </div>
</div>

<!-- US: 2636088 -->
<div class="updateEmail ">
  <div class="modal" #updateEmail id="sessionPopUp" tabindex="-1" role="dialog" data-bs-ackdrop="static"
       data-bs-keyboard="false">
    <div class="updateEmail-dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="sessionPopUpModalLabel">Please Confirm</h4>
          </div>
          <div class="modal-body">
            <div [innerHTML]="selectedSessionTypeDescription"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal"
                    (click)="yesBtnClicked()">
              YES
            </button>
            <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal"
                    (click)="NoBtnClicked()">
              NO
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
